
const surveyData = [
  {
    title: '1. Takım Değeri',
    questions: [
      { 
        id: 'q1', 
        text: 'Ortakların uzmanlık alanları', 
        type: 'radio', 
        options: [
          {
            option: 'Homojen dağılım (çeşitli alanlardan)',
            value: 75000,
            type: 'potential',
            sentences: [
              "Kurucu takımın teknoloji, satış ve pazarlama gibi farklı uzmanlık alanlarından gelmesi, başarı için ideal bir temel oluşturur.",
              "Araştırmalar, tamamlayıcı yetenek setlerine sahip takımların çok yönlü zorlukların üstesinden gelmede daha donanımlı olduğunu göstermektedir.",
              "Bu çeşitlilik, problem çözme süreçlerine geniş bir perspektif getirerek homojen takımlara kıyasla üstün performans sağlar.",
              "Yatırımcılar, bu dengeli yapıyı kritik fonksiyonların uzman ellerde olduğunu teyit ettiği için önemli bir risk azaltıcı faktör olarak görürler.",
              "Bu yetkinlik dağılımı, şirketin bir ürünü başarılı bir şekilde geliştirip pazara sunabileceğine dair güçlü bir sinyal verir."
            ]
          },
          {
            option: 'Hepsi yazılımcı',
            value: 20000,
            type: 'risk',
            sentences: [
              "Tamamı yazılımcılardan oluşan bir kurucu takım, güçlü bir teknik kapasiteye sahip olsa da ticari fonksiyonlarda önemli riskler taşır.",
              "Bu tür takımlar, satış, pazarlama ve finansal yönetim gibi alanlarda gerekli yetkinliklerden yoksun olabilirler.",
              "Bu homojen yapı, pazar ihtiyaçları yerine teknolojiye odaklanılmasına yol açarak ürünün pazarda karşılık bulamaması riskini artırır.",
              "Yatırımcılar için bu durum, ürünün ticarileşme potansiyeli konusunda ciddi bir endişe kaynağıdır.",
              "Takımın bu yetkinlik eksikliğini dış kaynaklarla gidermesi, başlangıç maliyetlerini ve operasyonel riskleri artıracaktır."
            ]
          },
          {
            option: 'Hepsi satışçı',
            value: 20000,
            type: 'risk',
            sentences: [
              "Tamamı satış profesyonellerinden oluşan bir takım, pazarla etkileşim kurmada mükemmel olabilir, ancak temel ürünü geliştirme konusunda teknik kapasiteden yoksundur.",
              "Bu durum, girişimi dış kaynaklı teknik yeteneklere temelden bağımlı kılar ve pazar geri bildirimleri ile ürün geliştirme arasında kopukluğa yol açabilir.",
              "Teknik bir kurucu ortağın yokluğu, girişimin inovasyon yapma ve pazar değişikliklerine hızla adapte olma yeteneğini ciddi şekilde tehlikeye atar.",
              "Bu temel eksiklik, şirketin uzun vadeli yaşayabilirliği üzerinde önemli bir risk oluşturur.",
              "Yatırımcılar, bu yapıyı temel ürün üzerinde kontrol eksikliği olarak değerlendirir ve bu durum yatırım kararını olumsuz etkileyebilir."
            ]
          }
        ] 
      },
      { 
        id: 'q2', 
        text: 'Ortakların birey başına ortalama iş deneyimi (yıl)', 
        type: 'radio', 
        options: [
          {
            option: '5+ yıl',
            value: 75000,
            type: 'potential',
            sentences: [
              "Ortakların ortalama beş yıldan fazla iş deneyimine sahip olması, profesyonel olgunluğa ve derin bir anlayışa sahip bir takıma işaret eder.",
              "Bu deneyim seviyesi, tecrübeli kurucuların yerleşik ağlarından faydalanabilmesi nedeniyle daha yüksek başarı oranlarıyla güçlü bir korelasyon göstermektedir.",
              "Yatırımcılar bu durumu, takımın zorluklar karşısında dayanıklılık ve stratejik öngörüye sahip olduğunu gösteren önemli bir risk azaltıcı faktör olarak görürler.",
              "Bu tecrübe, kurucuların yaygın başlangıç hatalarından kaçınmasına ve şirketi daha verimli bir şekilde ölçeklendirmesine olanak tanır.",
              "Bu deneyim seviyesi potansiyel işe alımlar ve stratejik ortaklıklar için bir güvenilirlik sinyali olarak işlev görür."
            ]
          },
          {
            option: '2-5 yıl',
            value: 50000,
            type: 'potential',
            sentences: [
              "Bu deneyim seviyesi, kurucuların kariyerlerinin giriş seviyesini aştığını ve sağlam temel becerilere sahip olduklarını gösterir.",
              "Genellikle modern bilgi birikimi ile pratik deneyim arasında iyi bir dengeye sahip olup, bu da onları oldukça çevik ve uyumlu kılar.",
              "Daha tecrübeli profesyonellerin geniş ağlarına sahip olmasalar da, genellikle yüksek adaptasyon yeteneği ve başarma azmi ile öne çıkarlar.",
              "Bu profil, büyüme ve uygulama potansiyeli açısından güçlü bir temel sunar.",
              "Yatırımcılar için bu seviye, takımın temel iş süreçlerini anladığı ancak aynı zamanda yeni yaklaşımlara açık olduğu anlamına gelir."
            ]
          },
          {
            option: '1-2 yıl',
            value: 25000,
            type: 'risk',
            sentences: [
              "Bir ila iki yıllık deneyime sahip kurucular, kariyerlerinin henüz başındadır ve taze bakış açıları getirebilirler.",
              "Ancak genellikle bir girişimin hayatta kalması için kritik olan derin endüstri bilgisi ve geniş profesyonel ağlardan yoksundurlar.",
              "Bu deneyimsizlik, finansal planlama ve stratejik karar verme gibi alanlarda yaygın hatalara yol açabilir.",
              "Yatırımcılar bu profili, takımın temel iş zorluklarıyla başa çıkma yeteneği konusunda daha fazla kanıta ihtiyaç duyduğu bir durum olarak değerlendirir.",
              "Bu tür takımların genellikle güçlü danışmanlar veya mentorlarla desteklenmesi beklenir."
            ]
          },
          {
            option: '1 yıldan az',
            value: 0,
            type: 'risk',
            sentences: [
              "Ortalama bir yıldan az profesyonel deneyime sahip bir takım, yatırımcılar için önemli bir kırmızı bayraktır.",
              "Bu durum, profesyonel iş akışlarına ve iş yürütmenin pratik zorluklarına maruz kalmamış bir ekibe işaret eder.",
              "Kritik iş becerilerindeki potansiyel boşluklar nedeniyle başarısızlık riski son derece yüksektir.",
              "Bu profil, girişimin temel zorluklarla başa çıkma kapasitesi hakkında ciddi şüpheler uyandırır.",
              "Yatırımcılar, bu kadar erken aşamadaki bir takıma yatırım yapmayı, kanıtlanmamış bir hipotez üzerine yüksek riskli bir bahis olarak görürler."
            ]
          }
        ] 
      },
      { 
        id: 'q3', 
        text: 'Ortakların birey başına ortalama sektör deneyimi (yıl)', 
        type: 'radio', 
        options: [
          {
            option: '9+ yıl',
            value: 50000,
            type: 'potential',
            sentences: [
              "Kapsamlı sektörel deneyim, takıma derin alan bilgisi ve değerli endüstri bağlantıları sağlar.",
              "Bu uzmanlık, müşteri sorunlarının daha doğru tanımlanmasını ve pazara uygun çözümler geliştirilmesini mümkün kılar.",
              "Yatırımcılar, bu tür bir deneyimi öğrenme eğrisini azalttığı ve pazara giriş riskini düşürdüğü için oldukça değerli bulur.",
              "Bu derinlemesine bilgi, şirketin stratejik konumlandırmasını güçlendirir ve rekabet avantajı yaratır.",
              "Sektördeki güvenilirlik, ilk müşterileri ve stratejik ortakları çekmeyi kolaylaştırır."
            ]
          },
          {
            option: '7-9 yıl',
            value: 40000,
            type: 'potential',
            sentences: [
              "Bu deneyim aralığı, kurucuların sektörde sağlam bir geçmişe ve itibara sahip olduğunu gösterir.",
              "Rekabet ortamını, kilit oyuncuları ve pazarın inceliklerini anlama konusunda yetkin oldukları varsayılır.",
              "Bu seviyedeki deneyim, hem müşteriler hem de yatırımcılar nezdinde güvenilirlik oluşturmak için yeterlidir.",
              "Kurucular, bu tecrübeleri sayesinde pazar trendlerini öngörebilir ve şirketi doğru yönde yönlendirebilirler.",
              "Bu durum, stratejik hataların olasılığını azaltır ve girişimin pazarda daha hızlı yol almasını sağlar."
            ]
          },
          {
            option: '5-7 yıl',
            value: 30000,
            type: 'potential',
            sentences: [
              "Beş ila yedi yıllık sektör deneyimi, kurucuların pazarı ve temel dinamiklerini anladığını gösteren güçlü bir işarettir.",
              "Bu seviye, girişimin ilk aşamalarında bilinçli kararlar almak için yeterli bir temel sağlar.",
              "Kurucular, sektördeki ana zorlukları ve fırsatları tanıyacak kadar deneyime sahiptirler.",
              "En tecrübeli uzmanların sahip olduğu derin ağlara veya nüanslı içgörülere henüz sahip olmayabilirler.",
              "Yine de bu deneyim, girişimin pazarda sağlam bir başlangıç yapması için önemli bir avantaj sunar."
            ]
          },
          {
            option: '2-5 yıl',
            value: 10000,
            type: 'potential',
            sentences: [
              "Bu deneyim aralığı, sektör hakkında temel bir anlayışa işaret eder ve hiç deneyim olmamasından daha iyidir.",
              "Kurucular, pazarın temel işleyişine aşinadır ancak sektörün karmaşıklıkları konusunda sınırlı bilgiye sahip olabilirler.",
              "Bu durum, daha deneyimli rakiplere kıyasla daha dik bir öğrenme eğrisiyle karşı karşıya kalacakları anlamına gelir.",
              "Yatırımcılar, bu takımların eksikliklerini danışmanlık veya stratejik işe alımlarla nasıl telafi etmeyi planladıklarını görmek isteyeceklerdir.",
              "Bu deneyim seviyesi, belirli bir potansiyel sunmakla birlikte, önemli bir gelişim alanı olduğunu da gösterir."
            ]
          },
          {
            option: '1-2 yıl',
            value: 5000,
            type: 'risk',
            sentences: [
              "Sınırlı sektör deneyimi, takımın pazar hakkında yalnızca yüzeysel bir bilgiye sahip olduğunu gösterir.",
              "Bu durum, hedef kitlenin ihtiyaçlarını yanlış anlama riskini artırır.",
              "Etkisiz bir pazara giriş stratejisi geliştirme olasılığı yüksektir.",
              "Girişim, sektördeki yerleşik oyuncularla rekabet ederken önemli bir dezavantajla başlar.",
              "Bu deneyim eksikliği, yatırımcılar için bir endişe kaynağıdır ve takımın öğrenme yeteneğinin olağanüstü olması gerekir."
            ]
          },
          {
            option: '1 yıldan az',
            value: 0,
            type: 'risk',
            sentences: [
              "İlgili sektör deneyiminin olmaması, büyük bir risk faktörü ve yatırımcılar için ciddi bir kırmızı bayraktır.",
              "Takım, sektörü sıfırdan öğrenmek zorunda kalacak, bu da stratejik hatalar yapma olasılığını artıracaktır.",
              "Pazar ihtiyaçlarını yanlış yorumlama ve hedef kitlede karşılık bulmayan bir ürün geliştirme riski yüksektir.",
              "Bu durum, yatırımcıları yalnızca takımın olağanüstü hızlı öğrenme yeteneğine bahis yapmaya zorlar.",
              "Girişimin, bu büyük bilgi boşluğunu kapatmak için önemli ölçüde dış uzmanlığa ihtiyacı olacaktır."
            ]
          }
        ]
      },
      {
        id: 'q4',
        text: 'Ortak sayısı',
        type: 'radio',
        options: [
            {
                option: '1 ortak',
                value: 12500,
                type: 'risk',
                sentences: [
                    "Tek kurucular tüm iş yükünü tek başlarına üstlenir ve karar alma süreçlerinde sınırlı bir bakış açısına sahiptir.",
                    "Bu durum, tükenmişlik riskini önemli ölçüde artırır.",
                    "Gelir açısından genellikle çok kuruculu şirketlerin gerisinde kalırlar.",
                    "Ölçeklenmelerinin daha uzun sürdüğü gösterilmektedir.",
                    "Yatırımcılar için tek bir kişiye olan bu bağımlılık, 'kilit kişi riski' olarak adlandırılan önemli bir endişe kaynağıdır."
                ]
            },
            
            {
                option: '2 ortak',
                value: 50000,
                type: 'potential',
                sentences: [
                    "İki kuruculu bir takım, genellikle iş yükünü paylaşma ve farklı becerileri birleştirme arasında ideal bir denge kurar.",
                    "Bu yapı, daha büyük takımlara kıyasla daha hızlı karar almayı mümkün kılar.",
                    "Tek kurucunun karşılaştığı izolasyon ve beceri boşluklarını ortadan kaldırır.",
                    "Araştırmalar, iki kuruculu takımların tek kuruculara göre daha hızlı yol aldığını göstermektedir.",
                    "Bu yapı, hem operasyonel verimlilik hem de psikolojik dayanıklılık açısından en uygun dengeyi sunar."
                ]
            },
            {
                option: '3 ortak',
                value: 37500,
                type: 'potential',
                sentences: [
                    "Üç kuruculu bir takım, daha geniş bir yetenek dağılımına olanak tanıyarak oldukça etkili olabilir.",
                    "Karar alma süreçlerinde doğal bir denge mekanizması sağlar.",
                    "Ancak, bu yapı daha fazla kişilerarası dinamik getirir ve hisse dağılımını karmaşıklaştırabilir.",
                    "Çatışmaları önlemek için rollerin ve sorumlulukların net bir şekilde tanımlanması hayati önem taşır.",
                    "Üç kişilik takımlarda, iki kurucunun bir araya gelerek üçüncüyü dışlama gibi siyasi riskler ortaya çıkabilir."
                ]
            },
            
            {
                option: '4 ortak',
                value: 25000,
                type: 'risk',
                sentences: [
                    "Dört kişilik bir kurucu takım, karar alma süreçlerinde gecikme ve kurucular arası çatışma riskini artırır.",
                    "Yatırımcılar, bu kadar çok kurucunun gerekliliğini sorgulayabilir, çünkü bu durum verimsizliğe işaret edebilir.",
                    "Her bir üye için hisse oranlarının azalması, bireysel motivasyonu ve uzun vadeli bağlılığı olumsuz etkileyebilir.",
                    "Sorumluluğun dağılması, hesap verebilirliği zorlaştırabilir.",
                    "Bu yapı, genellikle iç çekişmelere yol açma potansiyeli taşır."
                ]
            },
            {
                option: '4+ ortak',
                value: 0,
                type: 'risk',
                sentences: [
                    "Dörtten fazla kurucuya sahip takımlar, yatırımcılar için büyük bir kırmızı bayraktır.",
                    "İlişkileri yönetme ve vizyonları hizalama karmaşıklığı katlanarak artar.",
                    "Bu durum genellikle felce ve iç çatışmalara yol açar.",
                    "YCombinator'dan Paul Graham, bu tür takımların en iyi performans gösterenler arasında yer alma olasılığının düşük olduğunu belirtir.",
                    "Bu yapı, yönetimi zorlaştırır ve girişimin çevikliğini ciddi şekilde engeller."
                ]
            }
        ]
      },
      {
        id: 'q5',
        text: 'Global pazar deneyimi (en az 1 girişimci olması yeterlidir)',
        type: 'radio',
        options: [
            {
                option: '5+ yıl',
                value: 75000,
                type: 'potential',
                sentences: [
                    "Kapsamlı global pazar deneyimi, uluslararası hedefleri olan girişimler için derin bir rekabet avantajı sağlar.",
                    "Bu geçmişe sahip kurucular, kültürlerarası iş uygulamaları ve farklı düzenleyici ortamlar hakkında incelikli bir anlayışa sahiptir.",
                    "Araştırmalar, uluslararası deneyime sahip kurucuların daha başarılı uluslararasılaşma stratejileri izlediğini göstermektedir.",
                    "Bu deneyim, küresel genişlemenin doğasında var olan riskleri ve belirsizlikleri önemli ölçüde azaltır.",
                    "Yatırımcılar, bu tecrübeyi girişimin küresel ölçekte başarılı olma potansiyelinin güçlü bir göstergesi olarak görürler."
                ]
            },
            {
                option: '2-5 yıl',
                value: 50000,
                type: 'potential',
                sentences: [
                    "Bu deneyim seviyesi, uluslararası pazarlar hakkında temel bir anlayışa ve takımın küresel genişlemenin karmaşıklıklarının farkında olduğuna işaret eder.",
                    "Kurucular, yerelleştirme ve farklı yasal çerçevelerde gezinme gibi konularda bilgi sahibidirler.",
                    "Bu deneyim, bir girişimin ilk uluslararası hamlesiyle ilişkili riski azaltır.",
                    "Daha bilinçli bir strateji oluşturulmasına olanak tanır.",
                    "Takımın, bu temel bilgiyi kullanarak daha karmaşık küresel pazarlara giriş yapma potansiyeli yüksektir."
                ]
            },
            {
                option: '1-2 yıl',
                value: 25000,
                type: 'potential',
                sentences: [
                    "Bir ila iki yıllık global deneyim, uluslararası iş yapma konusunda bir miktar aşinalık olduğunu gösterir, ancak bu genellikle sınırlıdır.",
                    "Takım, küresel pazarların temel zorluklarını anlıyor olabilir, ancak derinlemesine stratejik planlamada yetersiz kalabilir.",
                    "Bu seviyedeki deneyim, hiç olmamasından daha iyidir.",
                    "Ancak yine de önemli bir öğrenme eğrisi gerektirecektir.",
                    "Girişimin, bu deneyim eksikliğini telafi etmek için uluslararası danışmanlara veya yerel ortaklara ihtiyacı olabilir."
                ]
            },
            {
                option: 'Yok',
                value: 0,
                type: 'risk',
                sentences: [
                    "Global pazar deneyiminin tamamen olmaması, girişimin uluslararası genişlemenin zorluklarına hazırlıksız olduğu anlamına gelir.",
                    "Bu zorluklar arasında alışılmadık kültürel nüanslar, karmaşık düzenleyici engeller ve yoğun küresel rekabet yer almaktadır.",
                    "Bu deneyim olmadan, takımın gereken kaynakları ve stratejik adaptasyonları hafife alması muhtemeldir.",
                    "Bu durum, küresel büyümeyi yüksek riskli ve yüksek maliyetli bir çabaya dönüştürür.",
                    "Yatırımcılar, bu eksikliği girişimin ölçeklenme potansiyelini ciddi şekilde sınırlayan bir faktör olarak görürler."
                ]
            }
        ]
      },
      {
        id: 'q6',
        text: 'Kuruculardan herhangi birinin daha önce girişimcilik deneyimi oldu mu?',
        type: 'radio',
        options: [
            {
                option: 'Evet',
                value: 75000,
                type: 'potential',
                sentences: [
                    "Daha önce girişimci olarak deneyim sahibi olmak, başarısız bir girişimde bile olsa son derece değerlidir.",
                    "Bu deneyim, fikir aşamasından fon yaratmaya kadar tüm girişim yaşam döngüsü hakkında ilk elden bilgi sağlar.",
                    "'Seri girişimciler', geçmiş hatalardan ders çıkarmış, ilgili ağlar kurmuş ve yatırımcıların aradığı dayanıklılığı göstermiştir.",
                    "Bu tecrübe, yeni girişimin yaygın tuzaklardan kaçınmasına ve daha hızlı ilerlemesine olanak tanır.",
                    "Bu tecrübe, yatırımcılar tarafından en çok aranan profillerden biridir."
                ]
            },
            
            
            {
                option: 'Hayır',
                value: 0,
                type: 'risk',
                sentences: [
                    "Girişimcilik dünyasına daha önce hiç maruz kalmamış olanlar, en dik öğrenme eğrisiyle karşı karşıyadır.",
                    "Ürün-pazar uyumu ve takım kurma gibi alanlarda yaygın ve önlenebilir hatalar yapma olasılıkları daha yüksektir.",
                    "Tutku ve harika bir fikir önemli olsa da, uygulama deneyiminin eksikliği girişimlerin başarısız olmasının birincil nedenlerinden biridir.",
                    "Bu durum, bu profili yatırımcılar için yüksek riskli kılar.",
                    "Bu takımların, deneyim eksikliklerini telafi etmek için güçlü bir danışman ağına sahip olmaları kritik öneme sahiptir."
                ]
            }
        ]
      },
      {
        id: 'q7',
        text: 'Girişimcinin şirkette full-time çalışması',
        type: 'radio',
        options: [
            {
                option: 'Evet',
                value: 50000,
                type: 'potential',
                sentences: [
                    "Kurucuların tam zamanlı adanmışlığı, çoğu yatırımcı için pazarlık konusu olmayan bir gerekliliktir.",
                    "Bu, takımın bir şirket kurmanın yoğun taleplerini yönetmeye tamamen yatırım yaptığını gösteren sarsılmaz bir adanmışlık sinyali verir.",
                    "Bu 'her şeyini ortaya koyma' yaklaşımı, engellerin üstesinden gelmek ve büyümeyi sağlamak için kritik öneme sahiptir.",
                    "Yatırımcılar, sermayelerini tamamen girişime adamış ekiplere yatırmayı tercih ederler.",
                    "Bu bağlılık, başarıya olan inancın en somut göstergesidir."
                ]
            },
            {
                option: 'Hayır',
                value: 0,
                type: 'risk',
                sentences: [
                    "Tam zamanlı bir adanmışlığın olmaması, erken aşama bir girişim için en önemli kırmızı bayraklardan biridir.",
                    "Bu durum, kurucuların tam olarak adanmadığını ve risklerini dağıttığını gösterir.",
                    "Bölünmüş dikkat, girişimin uygulama, yenilik yapma ve rekabet etme yeteneğini ciddi şekilde sınırlar.",
                    "Bu durum, onu çoğu risk sermayedarı için yatırım yapılamaz bir teklif haline getirir.",
                    "Girişimcilik, yarı zamanlı bir çaba olarak başarılı olamayacak kadar zorlu bir süreçtir."
                ]
            }
        ]
      },
      {
        id: 'q8',
        text: 'Girişimcinin erişebildiği ağın (network) büyüklüğü nedir?',
        type: 'radio',
        options: [
            {
                option: '5000+ kişi',
                value: 50000,
                type: 'potential',
                sentences: [
                    "Geniş bir profesyonel ağ, bir girişimin başarısını doğrudan etkileyen kritik bir maddi olmayan varlıktır.",
                    "Büyük bir ağ, potansiyel müşterilere, stratejik ortaklara, kilit personele ve yatırımcılara erişim sağlar.",
                    "Araştırmalar, kurucunun ağdaki merkeziliği ile fon toplama başarısı arasında güçlü bir korelasyon olduğunu göstermektedir.",
                    "Bu geniş ağ, girişimin pazarda daha hızlı hareket etmesine ve fırsatları daha verimli bir şekilde yakalamasına olanak tanır.",
                    "Bu, özellikle rekabetin yoğun olduğu sektörlerde belirleyici bir avantaj olabilir."
                ]
            },
            {
                option: '3000-5000 kişi arası',
                value: 37500,
                type: 'potential',
                sentences: [
                    "Bu büyüklükte bir ağ, kurucunun iyi bağlantılara sahip bir profesyonel olduğunu gösterir ve önemli bir değer taşır.",
                    "Girişimin ilk kaynaklara ve fırsatlara erişmesi için sağlam bir temel oluşturur.",
                    "Bu ağın stratejik olarak harekete geçirilmesi ve girişimin özel ihtiyaçlarına yönelik olarak büyütülmesi, başarının anahtarı olacaktır.",
                    "Kurucunun, bu mevcut ilişkileri derinleştirerek ve genişleterek girişimin hedeflerine ulaşmasını sağlaması beklenir.",
                    "Bu ağ, şirketin büyüme yolculuğunda önemli bir kaldıraç görevi görebilir."
                ]
            },
            {
                option: '1000-3000 kişi arası',
                value: 25000,
                type: 'potential',
                sentences: [
                    "Bu büyüklükteki bir ağ, profesyonel bir temel sunar ancak girişimin büyüme hedeflerini desteklemek için geliştirilmesi gerekebilir.",
                    "Kurucu, mevcut bağlantılarını bir başlangıç noktası olarak kullanmalı, ancak proaktif olarak yeni ilişkiler kurarak ağını genişletmelidir.",
                    "Fon yaratma ve stratejik ortaklıklar kurma sürecinde, bu ağın sınırlılıkları daha belirgin hale gelebilir.",
                    "Bu nedenle, ağ geliştirme, kurucunun öncelikli görevlerinden biri olmalıdır.",
                    "Bu ağın aktif olarak yönetilmesi, girişimin potansiyelini en üst düzeye çıkarmak için önemlidir."
                ]
            },
            {
                option: '0–1000 kişi arası', // JS dosyasındaki bu seçenek, PDF'teki '1000'den Az' ile eşleştirilmiştir.
                value: 12500,
                type: 'risk',
                sentences: [
                    "Daha küçük bir ağ, kurucunun dış kaynaklara ve fırsatlara kolayca erişme yeteneğini sınırlar.",
                    "Bu, aşılamaz bir engel olmasa da, takımın bağlantılar kurmak için önemli ölçüde daha fazla çaba sarf etmesi gerektiği anlamına gelir.",
                    "Bu durum, ilerlemeyi yavaşlatabilir ve fon toplama sürecini zorlaştırabilir.",
                    "Mentorlar bulmak ve yatırımcılara tanıtım almak daha fazla zaman alabilir.",
                    "Girişimin, bu eksikliği gidermek için ekosistem etkinliklerine aktif katılım ve proaktif ağ oluşturma stratejileri uygulaması gerekecektir."
                ]
            }
        ]
      },
      {
        id: 'q9',
        text: 'Takım üyelerinin motivasyonu ve bağlılığı nasıl?',
        type: 'radio',
        options: [
            {
                option: 'Yüksek motivasyon, bağlılık ve düşük çalışan sirkülasyonu',
                value: 125000, // PDF'te puan belirtilmemiş, mantıksal bir değer atanmıştır.
                type: 'potential',
                sentences: [
                    "Yüksek motivasyonlu ve bağlı bir takım, sağlıklı bir liderliğin ve pozitif bir çalışma kültürünün güçlü bir göstergesidir.",
                    "Bu ortam, bir girişimin baskılarıyla başa çıkmak için gerekli olan yeniliği, üretkenliği ve dayanıklılığı teşvik eder.",
                    "Düşük çalışan devir hızı, değerli kurumsal bilgiyi korur ve yatırımcılara takımın istikrarlı olduğu sinyalini verir.",
                    "Bu durum, şirketin uzun vadeli hedeflerine ulaşma olasılığını önemli ölçüde artırır.",
                    "Bu tür bir kültür, en iyi yetenekleri çekmek ve elde tutmak için de bir mıknatıs görevi görür."
                ]
            },
            {
                option: 'Orta düzey motivasyon',
                value: 25000, // PDF'te puan belirtilmemiş, mantıksal bir değer atanmıştır.
                type: 'potential',
                sentences: [
                    "Orta düzeyde bir motivasyon, liderlik, vizyon veya çalışma ortamında potansiyel sorunlara işaret edebilir.",
                    "Kritik bir başarısızlık olmasa da, girişimin en yüksek performansta çalışmasını engelleyebilir.",
                    "Bu durum, daha yavaş uygulamaya ve daha az yeniliğe yol açabilir.",
                    "Bu, moral ve performansta bir düşüşü önlemek için proaktif yönetim gerektiren bir uyarı işaretidir.",
                    "Liderliğin, motivasyon eksikliğinin temel nedenlerini anlamak ve gidermek için adımlar atması kritik öneme sahiptir."
                ]
            },
            {
                option: 'Düşük motivasyon, yüksek turnover riski',
                value: 0, // PDF'te puan belirtilmemiş, mantıksal bir değer atanmıştır.
                type: 'risk',
                sentences: [
                    "Bu, şirket içinde liderlik zafiyeti veya toksik bir kültür gibi köklü sorunları gösteren kritik bir kırmızı bayraktır.",
                    "Yüksek çalışan devir hızı maliyetli, yıkıcı ve iç işlev bozukluğunun açık bir işaretidir.",
                    "Yatırımcılar bunu büyük bir yürütme riski olarak görürler.",
                    "Motivasyonsuz ve istikrarsız bir takımın hedeflerine ulaşması pek olası değildir.",
                    "Bu durum, girişimin temelden kusurlu olduğunu ve sürdürülebilir bir başarı şansının çok düşük olduğunu gösterir."
                ]
            }
        ]
      },
    ]
  },
  {
    title: '2. Fikrin Değeri',
    questions: [
        { 
            id: 'q10', 
            text: 'Girişiminizin çözmeyi hedeflediği problem ne kadar net ve önemli?', 
            type: 'radio', 
            options: [
                {
                    option: 'Problem büyük, çözüm uygulanabilir ve ölçeklenebilir',
                    value: 125000,
                    type: 'potential',
                    sentences: [
                        "Bu seçenek, iyi tanımlanmış bir müşteri segmenti için önemli bir sorunu tespit eden ideal durumu temsil eder.",
                        "Bu netlik, müşterinin acı noktalarına dair derin bir anlayışı gösterir ve başarılı bir girişimin temel taşıdır.",
                        "Girişim, sadece bir ürün geliştirmekle kalmayıp, sürdürülebilir bir iş kurma yolunda olduğunu kanıtlamaktadır.",
                        "Yatırımcılar için bu durum, pazar ihtiyacının doğrulandığı ve çözümün ticari potansiyel taşıdığı anlamına gelir.",
                        "Bu yaklaşım, girişimin pazarda başarılı olma ve uzun vadeli değer yaratma olasılığını önemli ölçüde artırır."
                    ]
                },
                {
                    option: 'Problem belirli, çözüm denemesi var',
                    value: 65000,
                    type: 'potential',
                    sentences: [
                        "Girişim bir sorunu tanımlamış ancak çözümü doğrulama sürecindedir.",
                        "Bu, bir ilk çözümün geri bildirim toplamak için test edildiği yaygın bir erken aşamadır.",
                        "Buradaki temel risk, mevcut çözümün sorunu yeterince ele almaması ve bu durumun pivotlar gerektirmesidir.",
                        "Bu aşama, belirsizliğin yüksek olduğu ancak öğrenme potansiyelinin de bir o kadar fazla olduğu bir dönemdir.",
                        "Yatırımcılar, bu aşamadaki bir girişimin geri bildirimlere ne kadar hızlı yanıt verdiğini ve öğrenme yeteneğini yakından izler."
                    ]
                },
                {
                    option: 'Problem net değil, çözüm sınırlı',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Bu senaryo, en yüksek riskli durumu temsil eder ve genellikle 'bir problem arayışındaki çözüm' olarak tanımlanır.",
                        "Girişim, doğrulanmış müşteri ihtiyaçları yerine varsayımlara dayanarak bir ürün geliştirmeye odaklanmıştır.",
                        "Bu durum, başarısızlığın birincil nedenlerinden biridir.",
                        "Açıkça tanımlanmış ve önemli bir problem olmadan, sürdürülebilir bir iş için bir temel yoktur.",
                        "Yatırılan tüm kaynakların boşa gitme riski yüksektir."
                    ]
                }
            ] 
        },
        { 
            id: 'q11', 
            text: 'Problem maliyetli ve önemli bir alan mı?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 75000,
                    type: 'potential',
                    sentences: [
                        "Müşteriler için maliyetli veya yüksek değerli bir sorunu çözmek, uygulanabilir bir iş modeli için güçlü bir temel oluşturur.",
                        "Müşteriler, kendilerine önemli ölçüde para kazandıran veya büyük riskleri azaltan çözümler için ödeme yapmaya daha isteklidir.",
                        "Bu durum, müşteri başına daha yüksek potansiyel gelir ve daha net bir değer önerisi anlamına gelir.",
                        "Bu tür bir probleme odaklanmak, girişimin pazarda daha kolay benimsenmesini ve daha hızlı büyümesini sağlar.",
                        "Bu, aynı zamanda fiyatlandırma gücü ve daha yüksek kar marjları için de bir zemin hazırlar."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Müşteri için maliyetli veya önemli olmayan bir sorunu hedeflemek, sürdürülebilir bir iş kurmayı zorlaştırır.",
                        "Müşterilerin 'olsa iyi olur' türünden bir çözüm için ödeme yapma olasılığı düşüktür.",
                        "Bu durum, ticarileştirme ve ürün-pazar uyumuna ulaşmada zorluklara yol açar.",
                        "Genellikle düşük dönüşüm oranlarına ve yüksek müşteri kayıp oranına (churn) neden olur.",
                        "Yatırımcılar, bu tür girişimleri ölçeklenebilir bir gelir modeli oluşturma potansiyeli düşük olduğu için riskli bulur."
                    ]
                }
            ] 
        },
        { 
            id: 'q12', 
            text: 'Ürün geliştirme sürecinde sahadan geri bildirim alındı mı?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 125000,
                    type: 'potential',
                    sentences: [
                        "Müşteri geri bildirimini aktif olarak aramak, Lean Startup metodolojisinin temel taşıdır.",
                        "Bu, takımın kanıtlanmamış varsayımlar yerine 'doğrulanmış öğrenmeye' odaklandığını gösterir.",
                        "Bu müşteri merkezli yaklaşım, Problem-Çözüm Uyumu'na ulaşma şansını önemli ölçüde artırır.",
                        "Geri bildirim döngüsü, kaynakların israf edilmesini önler ve ürünün pazara daha uygun hale gelmesini sağlar.",
                        "Yatırımcılar için bu, takımın pazara duyarlı ve veriye dayalı kararlar alabildiğinin en güçlü kanıtıdır."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Müşteri geri bildirimi olmadan bir ürün geliştirmek, bir girişimin yapabileceği en ölümcül hatalardan biridir.",
                        "Bu, takımın tamamen sezgi ve varsayımlarla hareket ettiği anlamına gelir ki bunların yanlış olma olasılığı yüksektir.",
                        "Bu yaklaşım, kimsenin ihtiyaç duymadığı özellikler inşa ederek zaman ve kaynak israfına yol açar.",
                        "Yatırımcılar, bu durumu girişimin başarısızlık riskini en üst düzeye çıkaran temel bir metodolojik hata olarak görürler.",
                        "Pazarla temas kurmadan geliştirilen ürünler, neredeyse her zaman başarısız olmaya mahkumdur."
                    ]
                }
            ] 
        },
        { 
            id: 'q13', 
            text: 'Sorunun önemi önümüzdeki 5 yıl içinde devam edecek mi?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 75000,
                    type: 'potential',
                    sentences: [
                        "Dayanıklı ve uzun vadeli bir sorunu hedeflemek, girişimin sürdürülebilir bir pazar ihtiyacını karşıladığını garanti eder.",
                        "Bu, uzun vadeli büyüme için bir temel sağlar ve girişimi yatırımcılar için daha çekici hale getirir.",
                        "Pazar fırsatının geçici olmadığını ve şirket ölçeklendikçe destekleyici olacağını gösterir.",
                        "Bu durum, girişimin kalıcı bir değer yaratma potansiyeline sahip olduğunu işaret eder.",
                        "Sürdürülebilir bir probleme odaklanmak, marka oluşturma ve pazarda liderlik konumu elde etme için zaman tanır."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Kısa vadeli bir soruna veya geçici bir modaya odaklanmak, sınırlı uzun vadeli potansiyele sahip yüksek riskli bir iş modeli yaratır.",
                        "Çözümün pazarı ortadan kalkabilir, bu da ürünü geçersiz kılar ve sürdürülebilir bir şirket kurmayı imkansız hale getirir.",
                        "Yatırımcılar, uzun vadeli, ölçeklenebilir getiri potansiyelinden yoksun oldukları için bu tür girişimlere karşı temkinlidir.",
                        "Bu tür bir iş modeli, genellikle kalıcı bir rekabet avantajı oluşturmak için yeterli zaman sağlamaz.",
                        "Girişim, pazar kaybolmadan önce hızlı bir şekilde kar elde etme baskısı altında kalır."
                    ]
                }
            ] 
        },
        { 
            id: 'q14', 
            text: 'Bu problemi çözmek için özel veya ileri düzey teknik ya da uzmanlık bilgisi gerekiyor mu?',
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 100000,
                    type: 'potential',
                    sentences: [
                        "Çözülmesi için özel, ortalamanın üzerinde yetkinlik gerektiren bir sorun, rakipler için doğal bir giriş engeli oluşturur.",
                        "Bu teknik veya alana özgü karmaşıklık, güçlü bir savunma mekanizması veya 'hendek' (moat) olabilir.",
                        "Bu durum, kurucu takımın çözümlerini kopyalamayı zorlaştıran benzersiz becerilere sahip olduğunu gösterir.",
                        "Yatırımcılar, bu tür teknik engelleri, girişimin uzun vadeli kar marjlarını koruma yeteneğinin bir göstergesi olarak oldukça değerli bulurlar.",
                        "Bu, girişimin değerlemesini olumlu yönde etkileyen önemli bir faktördür."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Eğer sorunun çözümü basitse ve özel bir beceri gerektirmiyorsa, pazara giriş engeli düşüktür.",
                        "Bu, girişimin ürünü kolayca kopyalayabilen yeni rakiplerden yoğun bir rekabetle karşılaşacağı anlamına gelir.",
                        "Güçlü bir savunma avantajı olmadan, işletme yalnızca fiyat üzerinden rekabet etmek zorunda kalabilir.",
                        "Bu durum, düşük kar marjlarına ve karlılığa giden zorlu bir yola yol açar.",
                        "Yatırımcılar için bu, sürdürülebilir bir pazar liderliği kurmanın zor olduğu bir endişe kaynağıdır."
                    ]
                }
            ] 
        },
    ]
  },
  {
    title: '3. Pazar Değerlendirmesi',
    questions: [
        { 
    id: 'q20', 
    text: 'Lütfen çalıştığınız teknoloji alanını seçiniz:', 
    type: 'radio', 
    options: [
        {
            option: 'Yapay Zeka (AI)',
            value: 75000,
            type: 'potential',
            sentences: [
                "Yapay Zeka sektörü, teknoloji dünyasının en hızlı büyüyen ve en yüksek potansiyelli alanlarından biridir.",
                "Küresel AI pazarının 2032'de 1.77 trilyon dolara çıkması beklenmektedir, bu da büyük bir büyüme potansiyeli sunar.",
                "AI teknolojileri, hemen hemen her sektörde dönüştürücü etkiler yaratarak geniş uygulama alanları sunar.",
                "Bu alanda faaliyet gösteren girişimler, güçlü yatırımcı ilgisi ve üstel büyüme potansiyeli ile karşılaşır.",
                "Yapay zeka çözümleri, ölçeklenebilirlik ve küresel pazar erişimi açısından büyük avantajlar sağlar."
            ]
        },
        {
            option: 'Blockchain',
            value: 75000,
            type: 'potential',
            sentences: [
                "Blockchain teknolojisi, finans, tedarik zinciri ve dijital kimlik gibi birçok alanda devrim yaratma potansiyeline sahiptir.",
                "Merkezi olmayan finansal sistemler (DeFi) ve Web3 teknolojileri hızla gelişmekte ve yeni iş modelleri yaratmaktadır.",
                "Bu teknoloji, güvenlik, şeffaflık ve merkezi olmayan yapısıyla geleneksel sistemlere alternatif çözümler sunar.",
                "Blockchain alanındaki girişimler, erken aşama yatırımcılardan önemli ilgi görmektedir.",
                "Teknolojinin olgunlaşmasıyla birlikte, kurumsal adaptasyon hızla artmaktadır."
            ]
        },
        {
            option: 'Siber Güvenlik',
            value: 75000,
            type: 'potential',
            sentences: [
                "Artan siber tehditlerin etkisiyle siber güvenlik sektörü, kritik öneme sahip hızla büyüyen bir alan haline gelmiştir.",
                "Dijitalleşmenin artmasıyla birlikte, güvenlik çözümlerine olan talep sürekli olarak yükselmektedir.",
                "Bu sektör, hem kurumsal hem de bireysel müşterilere yönelik geniş bir pazar sunmaktadır.",
                "Siber güvenlik girişimleri, yüksek karlılık potansiyeli ve güçlü müşteri bağlılığı ile karakterize edilir.",
                "Teknolojik gelişmelerin hızıyla birlikte, yeni güvenlik tehditlerini önleyecek çözümlere sürekli ihtiyaç vardır."
            ]
        },
        {
            option: 'Sağlık Teknolojileri',
            value: 75000,
            type: 'potential',
            sentences: [
                "Sağlık teknolojileri sektörü, yaşlanma nüfusu ve artan sağlık ihtiyaçları nedeniyle büyük bir büyüme potansiyeline sahiptir.",
                "Dijital sağlık çözümleri, telemedicine ve AI destekli tanı sistemleri hızla benimsenmektedir.",
                "COVID-19 pandemisi, sağlık teknolojilerinin benimsenmesini hızlandırmış ve pazar büyümesini tetiklemiştir.",
                "Bu alan, hem sosyal etki yaratma hem de ticari başarı elde etme fırsatı sunar.",
                "Sağlık sektöründeki dijital dönüşüm, yenilikçi girişimler için büyük fırsatlar yaratmaktadır."
            ]
        },
        {
            option: 'FinTech',
            value: 75000,
            type: 'potential',
            sentences: [
                "FinTech sektörü, geleneksel finansal hizmetleri dönüştürerek büyük bir pazar payı elde etmiştir.",
                "Dijital ödemeler, borç verme ve yatırım platformları hızla büyümekte ve yeni müşteri segmentlerine ulaşmaktadır.",
                "Bu sektör, güçlü regülasyon desteği ve artan tüketici kabulü ile desteklenmektedir.",
                "FinTech girişimleri, yüksek büyüme oranları ve güçlü yatırımcı ilgisi ile karakterize edilir.",
                "Finansal kapsayıcılığın artması, bu alanda yeni fırsatlar yaratmaya devam etmektedir."
            ]
        },
        {
            option: 'Yeşil Teknolojiler',
            value: 75000,
            type: 'potential',
            sentences: [
                "İklim değişikliği ve sürdürülebilirlik odağı, yeşil teknolojiler sektörünü hızla büyütmektedir.",
                "Yenilenebilir enerji, karbon yakalama ve sürdürülebilir üretim alanlarında büyük yatırımlar yapılmaktadır.",
                "Hükümet teşvikleri ve regülasyon değişiklikleri, bu sektördeki girişimleri desteklemektedir.",
                "Yeşil teknoloji girişimleri, hem çevresel etki yaratma hem de ticari başarı fırsatı sunar.",
                "Kurumsal sürdürülebilirlik hedefleri, bu alandaki çözümlere olan talebi artırmaktadır."
            ]
        },
        {
            option: 'EdTech',
            value: 75000,
            type: 'potential',
            sentences: [
                "Eğitim teknolojileri sektörü, uzaktan öğrenme ve dijital eğitim araçlarının yaygınlaşmasıyla hızla büyümektedir.",
                "COVID-19 pandemisi, EdTech çözümlerinin benimsenmesini hızlandırmış ve pazar büyümesini tetiklemiştir.",
                "Kişiselleştirilmiş öğrenme ve AI destekli eğitim platformları, büyük potansiyel taşımaktadır.",
                "Bu sektör, hem bireysel hem de kurumsal müşterilere yönelik geniş bir pazar sunmaktadır.",
                "Yaşam boyu öğrenme kavramının yaygınlaşması, EdTech girişimleri için sürekli büyüyen bir pazar yaratmaktadır."
            ]
        },
        {
            option: 'Bulut Bilişim',
            value: 75000,
            type: 'potential',
            sentences: [
                "Bulut bilişim sektörü, dijital dönüşümün temel taşı olarak sürekli büyümektedir.",
                "İşletmelerin uzaktan çalışma modeline geçişi, bulut teknolojilerine olan talebi artırmıştır.",
                "SaaS, PaaS ve IaaS modelleri, girişimler için çeşitli iş modeli fırsatları sunmaktadır.",
                "Bu sektör, yüksek ölçeklenebilirlik ve tekrarlanan gelir potansiyeli ile karakterize edilir.",
                "Edge computing ve hibrit bulut çözümleri gibi yeni trendler, ek büyüme fırsatları yaratmaktadır."
            ]
        },
        {
            option: 'Elektrikli / Otonom Araçlar',
            value: 75000,
            type: 'potential',
            sentences: [
                "Elektrikli ve otonom araç teknolojileri, otomotiv sektöründe büyük bir dönüşüm yaratmaktadır.",
                "Hükümet teşvikleri ve çevresel regülasyonlar, bu alandaki büyümeyi hızlandırmaktadır.",
                "Batarya teknolojisi, otonom sürüş ve şarj altyapısı alanlarında büyük yatırımlar yapılmaktadır.",
                "Bu sektör, hem teknoloji hem de üretim açısından çeşitli girişim fırsatları sunmaktadır.",
                "Akıllı ulaştırma sistemleri ve mobilite hizmetleri, ek pazar segmentleri yaratmaktadır."
            ]
        },
        {
            option: 'Tarım Teknolojileri',
            value: 75000,
            type: 'potential',
            sentences: [
                "AgriTech sektörü, artan gıda ihtiyacı ve sürdürülebilir tarım arayışıyla büyük potansiyel taşımaktadır.",
                "Akıllı tarım, hassas çiftçilik ve vertical farming gibi teknolojiler hızla gelişmektedir.",
                "İklim değişikliği ve kaynak kıtlığı, tarım teknolojilerine olan talebi artırmaktadır.",
                "Bu alan, hem sosyal etki yaratma hem de ticari başarı elde etme fırsatı sunar.",
                "IoT, AI ve robotik teknolojilerinin tarımda uygulanması, yeni iş modelleri yaratmaktadır."
            ]
        },
        {
            option: 'Sürdürülebilirlik',
            value: 75000,
            type: 'potential',
            sentences: [
                "Sürdürülebilirlik teknolojileri, iklim hedefleri ve kurumsal sorumluluk odağıyla hızla büyümektedir.",
                "Karbon ayak izi yönetimi, döngüsel ekonomi ve sürdürülebilir üretim alanlarında büyük fırsatlar vardır.",
                "ESG hedefleri ve regülasyon değişiklikleri, bu sektördeki çözümlere olan talebi artırmaktadır.",
                "Sürdürülebilirlik girişimleri, güçlü yatırımcı ilgisi ve kurumsal ortaklık fırsatları ile karşılaşır.",
                "Tüketici bilinç düzeyinin artması, sürdürülebilir teknolojiler için büyüyen bir pazar yaratmaktadır."
            ]
        },
        {
            option: 'IoT (Nesnelerin İnterneti)',
            value: 50000,
            type: 'potential',
            sentences: [
                "IoT teknolojileri, endüstri 4.0 ve akıllı şehirler konseptiyle birlikte olgun bir büyüme aşamasına girmiştir.",
                "Bu alan, çeşitli sektörlerde verimlilik artışı ve maliyet azaltma fırsatları sunmaktadır.",
                "IoT çözümleri, istikrarlı büyüme potansiyeli olan etabli bir pazar segmentinde yer alır.",
                "Sensör teknolojileri ve bağlantı çözümleri, sürekli gelişen ve büyüyen bir ekosistem yaratmaktadır.",
                "Endüstriyel IoT uygulamaları, işletmeler için ölçülebilir değer yaratma potansiyeli taşır."
            ]
        },
        {
            option: 'VR / AR (Sanal ve Artırılmış Gerçeklik)',
            value: 50000,
            type: 'potential',
            sentences: [
                "VR/AR teknolojileri, eğitim, eğlence ve endüstriyel uygulamalarda giderek daha fazla benimsenmeye başlamıştır.",
                "Metaverse konsepti ve uzaktan çalışma trendleri, bu teknolojilere olan ilgiyi artırmaktadır.",
                "Bu alan, teknolojik olgunlaşma sürecinde olup, yeni uygulama alanları keşfetmektedir.",
                "VR/AR çözümleri, özellikle kurumsal eğitim ve pazarlama alanlarında büyüme potansiyeli göstermektedir.",
                "Donanım maliyetlerinin düşmesi, bu teknolojilerin daha geniş kitlelere ulaşmasını sağlamaktadır."
            ]
        },
        {
            option: 'E-ticaret & Dijital Pazarlama',
            value: 50000,
            type: 'potential',
            sentences: [
                "E-ticaret ve dijital pazarlama, olgun pazarlar olmasına rağmen hala büyüme fırsatları sunmaktadır.",
                "Yeni teknolojiler ve değişen tüketici davranışları, bu alanda yenilik fırsatları yaratmaktadır.",
                "Bu sektörde başarılı olmak için güçlü farklılaşma ve niş pazarlara odaklanma gereklidir.",
                "Sosyal ticaret, sesli ticaret ve AI destekli kişiselleştirme gibi trendler büyüme yaratmaktadır.",
                "Omnichannel deneyimler ve müşteri verisi analizi, rekabet avantajı sağlayabilir."
            ]
        },
        {
            option: 'Robotik',
            value: 50000,
            type: 'potential',
            sentences: [
                "Robotik teknolojileri, endüstriyel otomasyon ve hizmet robotları alanlarında istikrarlı büyüme göstermektedir.",
                "İmalat sektörü ve lojistik alanında robotik çözümlere olan talep artmaktadır.",
                "Bu alan, teknolojik gelişmelerle birlikte yeni uygulama alanları bulmaktadır.",
                "Robotik girişimleri, özellikle B2B segmentinde değer yaratma potansiyeline sahiptir.",
                "İnsan-robot işbirliği ve kolaboratif robotlar, büyüyen bir pazar segmenti oluşturmaktadır."
            ]
        },
        {
            option: '3D Baskı',
            value: 50000,
            type: 'potential',
            sentences: [
                "3D baskı teknolojileri, prototipleme aşamasından üretim aşamasına geçiş yaparak olgunlaşmaktadır.",
                "Özelleştirme ihtiyacı ve küçük seri üretim talepleri, bu alanda büyüme yaratmaktadır.",
                "Sağlık, havacılık ve otomotiv sektörlerinde 3D baskı uygulamaları artmaktadır.",
                "Bu teknoloji, geleneksel üretim yöntemlerine alternatif çözümler sunarak pazar payı kazanmaktadır.",
                "Malzeme teknolojisindeki ilerlemeler, 3D baskının uygulama alanlarını genişletmektedir."
            ]
        },
        {
            option: 'Oyun',
            value: 50000,
            type: 'potential',
            sentences: [
                "Oyun sektörü, mobil oyunlar ve çevrimiçi oyun platformlarıyla istikrarlı büyüme göstermektedir.",
                "E-spor ve oyun streaming platformları, sektörde yeni gelir kaynakları yaratmaktadır.",
                "Bu alan, yaratıcılık ve teknolojinin birleştiği, geniş kitle etkileşimi olan bir sektördür.",
                "Oyun içi satın almalar ve abonelik modelleri, sürdürülebilir gelir akışları sağlamaktadır.",
                "VR oyunlar ve artırılmış gerçeklik deneyimleri, sektörde yeni büyüme alanları yaratmaktadır."
            ]
        },
        {
            option: 'Diğer',
            value: 50000,
            type: 'potential',
            sentences: [
                "Farklı teknoloji alanlarında da başarılı girişim örnekleri bulunmaktadır.",
                "Niş pazarlar ve özel çözümler, büyük başarı potansiyeli taşıyabilir.",
                "Her sektörün kendine özgü fırsatları ve büyüme dinamikleri bulunmaktadır.",
                "Özgün iş modelleri ve yenilikçi yaklaşımlar, herhangi bir alanda başarı yaratabilir.",
                "Pazar büyüklüğünden ziyade, değer yaratma ve müşteri problemlerini çözme odaklı olmak önemlidir."
            ]
        }
    ] 
},
        { 
            id: 'q21', 
            text: 'Pazar büyüklüğü', 
            type: 'radio', 
            options: [
                {
                    option: 'Çok geniş, uluslararası bir pazar',
                    value: 100000,
                    type: 'potential',
                    sentences: [
                        "Çok büyük ve uluslararası bir Toplam Adreslenebilir Pazar (TAM), 'unicorn' seviyesinde bir sonuç potansiyeline işaret eder.",
                        "Bu, şirketin pazarın sadece küçük bir bölümünü ele geçirerek bile milyarlarca dolarlık bir iş kurmasına olanak tanır.",
                        "Pazar içindeki çeşitlilik, birden fazla ürün hattı geliştirme ve ek avantajlar sunar.",
                        "Yatırımcılar için bu, büyüme potansiyelinin neredeyse sınırsız olduğu anlamına gelir.",
                        "Bu ölçek, en iyi yetenekleri çekmek ve büyük ölçekli stratejik ortaklıklar kurmak için bir kaldıraç görevi görür."
                    ]
                },
                {
                    option: 'Geniş ve yüksek büyüme potansiyeline sahip',
                    value: 75000,
                    type: 'potential',
                    sentences: [
                        "Güçlü büyüme dinamiklerine sahip büyük bir Hizmet Verilebilir Mevcut Pazar (SAM), oldukça çekicidir.",
                        "Bu, girişimin gerçekçi bir şekilde hedefleyebileceği açık ve erişilebilir bir pazar segmentinin varlığını gösterir.",
                        "Yüksek büyüme oranı, pazarın genişlediğini ve yeni müşteriler edinmenin daha kolay olduğunu ima eder.",
                        "Bu durum, pazara girişin daha az maliyetli ve daha az sürtünmeli olabileceği anlamına gelir.",
                        "Yatırımcılar, bu tür pazarları girişimin hızla pazar payı kazanabileceği verimli bir zemin olarak görürler."
                    ]
                },
                {
                    option: 'Orta büyüklükte, gelişme potansiyeli olan',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Orta büyüklükte bir pazar, girişimin başarılı olmak için Hizmet Verilebilir Elde Edilebilir Pazarının (SOM) daha önemli bir bölümünü ele geçirmesini gerektirir.",
                        "Bu pazarda yaşayabilir bir iş kurulabilirken, pazar büyüklüğündeki sınırlı tavan nihai getiri potansiyelini sınırlayabilir.",
                        "Bu durum, onu en üst düzey risk sermayesi fonları için daha az çekici bir teklif haline getirebilir.",
                        "Girişimin, bu pazarda lider olmak için çok net bir niş stratejisine sahip olması gerekir.",
                        "Üstün bir ürün veya hizmet sunmak, bu pazarda başarı için kritik öneme sahiptir."
                    ]
                },
                {
                    option: 'Niş ve daha sınırlı bir pazar',
                    value: 25000,
                    type: 'risk',
                    sentences: [
                        "Küçük, yerel veya niş bir pazar, bir girişimin büyüme potansiyelini ciddi şekilde kısıtlar.",
                        "Bu tür işletmeler, genellikle risk sermayesiyle ölçeklenebilecek şirketler yerine 'yaşam tarzı işletmeleri' olarak kabul edilir.",
                        "Sınırlı TAM, pazarın %100'ünü ele geçirse bile gelir potansiyelinin yetersiz olduğu anlamına gelir.",
                        "Bu nedenle, bu tür girişimler genellikle risk sermayesi yatırımı için uygun görülmez.",
                        "Bu pazarlar, sürdürülebilir ancak sınırlı büyüme potansiyeli sunar."
                    ]
                }
            ] 
        },
        { 
            id: 'q22', 
            text: 'Pazardaki rekabet durumu', 
            type: 'radio', 
            options: [
                {
                    option: 'Henüz kuvvetli rakip yok',
                    value: 100000,
                    type: 'potential',
                    sentences: [
                        "Güçlü rakiplerin olmadığı bir 'mavi okyanus' pazarına girmek, önemli bir ilk hamle avantajı sağlar.",
                        "Girişim, pazarı tanımlama ve önemli bir pazar payı ele geçirme fırsatına sahiptir.",
                        "Diğerleri girmeden önce güçlü bir marka tanınırlığı oluşturabilir.",
                        "Bu, son derece arzu edilen bir senaryodur, ancak pazarın varlığını doğrulamak gerekir.",
                        "Başarılı olunduğunda, bu girişim pazarın standardını belirleyebilir."
                    ]
                },
                {
                    option: 'Rakip bulunmuyor',
                    value: 75000,
                    type: 'potential', // Potansiyel bir risk de içerir
                    sentences: [
                        "Görünüşte olumlu olsa da, rakiplerin tamamen olmaması bir uyarı işareti olabilir.",
                        "Bu durum, pazarın mevcut olmadığını veya sorunun çözülecek kadar önemli olmadığını gösterebilir.",
                        "Önceki girişimlerin belirgin olmayan nedenlerle başarısız olmuş olma ihtimali vardır.",
                        "Bu senaryo, girişimin gerçekten keşfedilmemiş bir fırsat mı yoksa bir 'pazar serabı' mı bulduğunu doğrulamak için ekstra özen gerektirir.",
                        "Yatırımcılar, bu durumda pazarın varlığını kanıtlamak için daha fazla veri talep edecektir."
                    ]
                },
                {
                    option: 'Kuvvetli büyük rakipler var',
                    value: 50000,
                    type: 'risk',
                    sentences: [
                        "Güçlü, yerleşik rakiplere ('kırmızı okyanus') karşı rekabet etmek zorlu ve sermaye yoğundur.",
                        "Girişimin başarılı olmak için net ve zorlayıcı bir farklılaşma noktasına sahip olması gerekir.",
                        "Bu, 10 kat daha iyi bir ürün, yıkıcı bir iş modeli veya benzersiz bir dağıtım kanalı olabilir.",
                        "Önemli bir rekabet avantajı olmadan, yerleşik rakipler yeni girenleri ezebilir.",
                        "Bu pazarda başarılı olmak, genellikle niş bir alana odaklanmayı gerektirir."
                    ]
                },
                {
                    option: 'Yıkıcı rekabet var',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Yıkıcı, fiyat savaşı odaklı bir rekabetin olduğu bir pazarda bir girişimin hayatta kalması son derece zordur.",
                        "Girişimler, fiyat üzerinden rekabet etmek için gereken ölçeğe ve sermaye rezervlerine sahip değildir.",
                        "Bu durum, sürdürülemez nakit yakma oranlarına ve sıkıştırılmış kar marjlarına yol açar.",
                        "Bu ortam, karlılığa giden yolun belirsiz olması nedeniyle yatırımcılar için büyük bir kırmızı bayraktır.",
                        "Bu tür pazarlarda, değer yaratmak yerine değer yok edilir, bu da onu bir girişim için en istenmeyen senaryolardan biri yapar."
                    ]
                }
            ] 
        },
        { 
            id: 'q23', 
            text: 'Pazarda gelişen yeni teknolojinin ürününüze etkisi nedir?', 
            type: 'radio', 
            options: [
                {
                    option: 'Pozitif (büyümesini destekliyor, yeni fırsatlar yaratıyor)',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Girişimin ürününün, yapay zeka gibi büyük bir teknolojik trendle uyumlu olması ona bir 'pazar rüzgarı' sağlar.",
                        "Bu, ürünü zamanla daha alakalı, güçlü ve ölçeklenebilir hale getirir.",
                        "Bu uyum, takımın ileri görüşlü olduğunu ve gelecek için bir çözüm inşa ettiğini gösterir.",
                        "Yatırımcılar, bu konumlandırmayı girişimin teknolojik değişim dalgalarını bir fırsat olarak kullanma yeteneğinin bir işareti olarak görürler.",
                        "Bu durum, girişimin uzun vadeli geçerliliğini ve büyüme potansiyelini artırır."
                    ]
                },
                {
                    option: 'Negatif (büyümesini yavaşlatıyor veya durduruyor)',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Girişimin teknolojik bir değişimin yanlış tarafında olması, ürününün bozulma veya eskime riski altında olduğu anlamına gelir.",
                        "Örneğin, bir endüstrinin hızla buluta geçtiği bir dönemde şirket içi (on-premise) bir yazılım çözümü sunmak gibi.",
                        "Bu, tüm girişimin uzun vadeli yaşayabilirliğini tehdit eden kritik bir stratejik risktir.",
                        "Yatırımcılar, pazarın tersine giden veya teknolojik olarak geride kalma riski taşıyan girişimlerden kaçınırlar.",
                        "Bu durum, girişimin pazar payını kaybetmesine ve sonunda alakasız hale gelmesine neden olabilir."
                    ]
                }
            ] 
        },
        { 
            id: 'q24', 
            text: 'Pivot ettiniz mi?', 
            tooltip: 'Pivot: Kullanıcı geri bildirimi veya piyasa koşullarıyla iş modelinde yapılan stratejik yön değişikliği.',
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 100000,
                    type: 'potential',
                    sentences: [
                        "Verilere dayanan bir pivot geçmişi, birçok yatırımcı tarafından olumlu karşılanır.",
                        "Bu, takımın uyarlanabilir ve pazar geri bildirimlerine duyarlı olduğunu gösterir.",
                        "Başarısız bir fikre duygusal olarak bağlı olmadıklarını kanıtlar.",
                        "Başarılı bir pivot, ürün-pazar uyumunu bulmaya öncelik veren dayanıklı bir takımın güçlü bir sinyalidir.",
                        "Bu, takımın öğrenme ve evrim geçirme yeteneğini kanıtlar, ki bu da erken aşama bir girişim için en önemli özelliklerden biridir."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Girişim erken bir çekiş yakaladıysa bu durum olumsuz değildir.",
                        "Ancak, diğer metrikler zayıfsa 'Hayır' yanıtı bir endişe kaynağı olabilir.",
                        "Bu, takımın ya pazar geri bildirimlerini dinlemediğini ya da düşüncelerinde çok katı olduğunu gösterebilir.",
                        "Yatırımcılar, pivot eksikliğinin erken başarıdan mı yoksa tehlikeli bir zihniyetten mi kaynaklandığını anlamak isteyeceklerdir.",
                        "Özellikle Problem-Çözüm Uyumu kanıtlanmamışsa, pivot yapmamak takımın öğrenme döngüsünü yönetemediğine işaret edebilir."
                    ]
                }
            ] 
        },
        { 
            id: 'q25', 
            text: 'Regülasyona bağlılık durumu nedir? Ürünün satışını destekleyen yasal bir regülasyon var mı?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Destekleyici bir yasal düzenleme, güçlü bir pazar rüzgarı ve bir giriş engeli olarak işlev görür.",
                        "Bir yasa, girişimin ürünü için bir ihtiyaç yaratıyorsa, bu durum bir 'esir pazar' yaratabilir ve benimsemeyi hızlandırabilir.",
                        "Bu, işin pazar talebi bileşenindeki riski azaltır.",
                        "Girişime pazarda anında bir meşruiyet kazandırır.",
                        "Bu tür düzenlemeler, yeni rakiplerin pazara girmesini zorlaştırarak mevcut girişime bir koruma kalkanı sağlar."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Düzenleyici bir gri alanda faaliyet göstermek veya potansiyel olumsuz düzenlemelerle karşı karşıya kalmak, önemli belirsizlik ve riskler getirir.",
                        "Olumsuz düzenleyici değişiklikler, bir iş modelini bir gecede yok edebilir.",
                        "Bu düzenleyici risk, pazarın uzun vadeli yaşayabilirliğini öngöremeyen yatırımcıları caydırabilir.",
                        "Bu belirsizlik, girişimin ölçeklenmesini ve uzun vadeli planlama yapmasını zorlaştırır.",
                        "Bu durum, onu daha az çekici bir yatırım haline getirir."
                    ]
                }
            ] 
        },
        { 
            id: 'q26', 
            text: 'Rakiplerinize Karşı Üstünlükleriniz (Çoktan seçmeli)', 
            type: 'checkbox', 
            options: [
                {
                    option: 'Fiyat avantajı',
                    value: 20000,
                    type: 'potential',
                    sentences: [
                        "Fiyat avantajı, genellikle ölçek ekonomileriyle elde edilir.",
                        "Donanım veya üretim içeren işlerde daha sürdürülebilirdir.",
                        "Pazara hızlı nüfuz etme imkanı sunar.",
                        "Fiyat hassasiyeti yüksek müşteri segmentlerini kazanma imkanı sağlar.",
                        "Ancak rakipler tarafından kolayca taklit edilebilir bir stratejidir."
                    ]
                },
                {
                    option: 'Teknolojik üstünlük',
                    value: 20000,
                    type: 'potential',
                    sentences: [
                        "Teknolojik üstünlük, rakiplerin kopyalaması zor olan bir çözüm sunar.",
                        "Genellikle '10 kat daha iyi' bir çözüm olarak ifade edilir.",
                        "Pazarda güçlü bir 'hendek' (moat) ve savunma mekanizması oluşturabilir.",
                        "Yüksek kar marjları ve pazar liderliği için temel oluşturur.",
                        "Sürekli Ar-Ge yatırımı gerektirir."
                    ]
                },
                {
                    option: 'Kullanıcı deneyimi',
                    value: 20000,
                    type: 'potential',
                    sentences: [
                        "Üstün kullanıcı deneyimi (UX), müşteri sadakati ve viral büyüme için kritik bir faktördür.",
                        "Sürekli kullanıcı geri bildirimi ve iterasyon gerektirir.",
                        "Müşteri kaybını (churn) azaltır ve marka elçileri yaratır.",
                        "Organik büyümeyi güçlü bir şekilde destekler.",
                        "Rakiplerin kopyalaması zor olan bir kültür ve süreç gerektirir."
                    ]
                },
                {
                    option: 'Patent veya koruma',
                    value: 20000,
                    type: 'potential',
                    sentences: [
                        "Fikri mülkiyet koruması, rakiplerin yasal olarak taklit edemeyeceği bir avantaj sağlar.",
                        "Pazarda geçici bir tekel veya güçlü bir avantaj yaratabilir.",
                        "Yatırımcılar için girişim değerini artıran önemli bir unsurdur.",
                        "Uzun vadeli pazar hakimiyeti için yasal bir koruma kalkanı görevi görür.",
                        "Ancak patentlerin alınması ve korunması maliyetli olabilir."
                    ]
                },
                {
                    option: 'Hızlı servis ve destek',
                    value: 20000,
                    type: 'potential',
                    sentences: [
                        "Mükemmel müşteri hizmeti, özellikle rekabetin yoğun olduğu pazarlarda önemli bir farklılaştırıcıdır.",
                        "Müşteri memnuniyetini ve yaşam boyu değerini (LTV) artırır.",
                        "Olumlu ağızdan ağıza pazarlamayı (word-of-mouth) teşvik eder.",
                        "Marka sadakati oluşturmada kilit rol oynar.",
                        "Rakiplerin standartlarını aşan bir hizmet kültürü gerektirir."
                    ]
                },
                {
                    option: 'Diğer',
                    value: 20000,
                    type: 'potential',
                    sentences: [
                        "Bu kategori, benzersiz iş modelleri gibi diğer avantajları içerir.",
                        "Özel ve kopyalanması zor dağıtım kanalları bu kapsama girebilir.",
                        "Kurucu takımın kişisel itibarı ve network'ü de bir avantaj olabilir.",
                        "Sektöre özgü, sürdürülebilir ve rakiplerin beklemediği bir alanda farklılaşma sağlar.",
                        "Pazarda benzersiz bir konum elde etme imkanı sunar."
                    ]
                }
            ] 
        },
    ]
  },
  {
    title: '4. Prototip / Ürün Durumu',
    questions: [
        { 
            id: 'q30', 
            text: 'MVP var mı?', 
            tooltip: 'MVP: Ürünün en basit, çalışır versiyonu; hızlıca test edip geri bildirim toplamak için geliştirilir.',
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 100000,
                    
                    type: 'potential',
                    sentences: [
                        "Minimum Uygulanabilir Ürün'e (MVP) sahip olmak, girişimin Lean Startup metodolojisini benimsediğini gösterir.",
                        "MVP, takımın varsayımlarını gerçek kullanıcılarla test etmesine ve değerli geri bildirimler toplamasına olanak tanır.",
                        "Bu yaklaşım, iş fikrinin geçerliliğini büyük yatırımlar yapmadan önce doğrulamak için düşük riskli bir yol sunar.",
                        "Yatırımcılar için bir MVP'nin varlığı, takımın ürün-pazar uyumunu bulmada veriye dayalı bir yaklaşım sergilediğinin kanıtıdır.",
                        "Bu durum, girişimin yatırım riskini önemli ölçüde azaltır ve başarı şansını artırır."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Bir MVP'nin olmaması, girişimin henüz temel iş hipotezlerini test etmeye başlamadığını gösterir.",
                        "Bu durum, takımın hala varsayımlar üzerine hareket ettiği ve pazarın ürüne olan ilgisini doğrulamadığı anlamına gelir.",
                        "MVP olmadan geliştirme sürecine devam etmek, müşteri tarafından istenmeyen bir ürün inşa etme riskini artırır.",
                        "Yatırımcılar, bu durumu girişimin doğrulanmış öğrenme sürecini atladığı şeklinde yorumlar.",
                        "Bu, yatırım yapılabilirlik açısından önemli bir eksikliktir."
                    ]
                }
            ] 
        },
        { 
            id: 'q31', 
            text: 'Ürün / teknoloji kopyalanması zor mu?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 75000,
                    type: 'potential',
                    sentences: [
                        "Kopyalanması zor bir ürün veya teknolojiye sahip olmak, sürdürülebilir bir rekabet avantajı veya 'hendek' (moat) oluşturur.",
                        "Bu savunulabilirlik; patentli teknoloji, karmaşık algoritmalar veya özel veri setleri gibi faktörlerden kaynaklanabilir.",
                        "Bu durum, rakiplerin pazara girmesini zorlaştırır ve girişimin pazar payını korumasına olanak tanır.",
                        "Yatırımcılar, bu tür savunulabilir varlıkları girişimin uzun vadeli değer yaratma potansiyelinin güçlü bir göstergesi olarak görürler.",
                        "Bu, şirketin pazardaki konumunu sağlamlaştırır ve değerlemesini artırır."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Kolayca kopyalanabilen bir ürün, girişimi sürekli bir rekabet baskısı altında bırakır.",
                        "Düşük giriş engelleri, yeni rakiplerin hızla pazara girmesine ve pazar payını aşındırmasına olanak tanır.",
                        "Bu durumda, girişim genellikle fiyat veya pazarlama gibi daha az sürdürülebilir alanlarda rekabet etmek zorunda kalır.",
                        "Savunulabilir bir teknolojik avantajın olmaması, uzun vadeli karlılığı sürdürmeyi zorlaştırır.",
                        "Yatırımcılar için bu, girişimin kalıcı bir değer yaratma yeteneği konusunda önemli bir endişe kaynağıdır."
                    ]
                }
            ] 
        },
        { 
            id: 'q32', 
            text: 'Satış döngüsü süresi', 
            type: 'radio', 
            options: [
                {
                    option: '1 ay veya daha az',
                    value: 100000,
                    type: 'potential',
                    sentences: [
                        "Bir aydan kısa bir satış döngüsü, son derece verimli bir pazara giriş modeline işaret eder ve hızlı gelir artışı sağlar.",
                        "Bu durum, nakit akışını hızlandırır ve müşteri edinme maliyetini (CAC) düşürür.",
                        "Kısa satış döngüleri, genellikle ürünün değer önerisinin net olduğunu ve pazarda güçlü bir çekiş olduğunu gösterir.",
                        "Yatırımcılar için bu, sermayenin hızla büyümeye dönüştürülebileceği, ölçeklenebilir bir iş modelinin kanıtıdır.",
                        "Şirketin büyümesini daha öngörülebilir hale getirir."
                    ]
                },
                {
                    option: '1-3 ay',
                    value: 60000,
                    type: 'potential',
                    sentences: [
                        "Bir ila üç aylık bir satış döngüsü, özellikle B2B pazarlarda oldukça sağlıklı ve yönetilebilir bir süredir.",
                        "Bu zaman dilimi, şirketin gelirlerini makul bir hızda artırmasına ve nakit akışını planlamasına olanak tanır.",
                        "Döngü, müşterilerle ilişki kurmak için yeterli zamanı sunarken, aşırı uzun bekleme sürelerinin risklerini en aza indirir.",
                        "Bu, istikrarlı ve ölçeklenebilir bir büyüme potansiyeli gösteren sağlam bir operasyonel verimlilik işaretidir.",
                        "Bu süre, pazarın ürünü benimseme hızını da yansıtır."
                    ]
                },
                {
                    option: '3-6 ay',
                    value: 40000,
                    type: 'potential',
                    sentences: [
                        "Üç ila altı aylık bir satış döngüsü, özellikle karmaşık kurumsal satışlarda yaygındır.",
                        "Ancak erken aşama bir girişim için zorluklar yaratabilir.",
                        "Bu süre, gelir elde etmeyi yavaşlatır ve şirketin nakit akışı üzerindeki baskıyı artırır.",
                        "Bu durum, daha fazla başlangıç sermayesi gerektirebilir.",
                        "Yatırımcılar, bu süreyi kısaltmak için geliştirilen stratejileri görmek isteyeceklerdir."
                    ]
                },
                {
                    option: '6-12 ay',
                    value: 20000,
                    type: 'risk',
                    sentences: [
                        "Altı ila on iki aylık bir satış döngüsü, erken aşama bir girişim için önemli bir risktir.",
                        "Bu kadar uzun bir süre, gelir yaratmayı ciddi şekilde geciktirir ve şirketin 'pistini' (runway) hızla tüketir.",
                        "Bu durum, müşteri edinme maliyetini (CAC) önemli ölçüde artırır ve yatırım getirisini (ROI) belirsizleştirir.",
                        "Yatırımcılar, bu kadar uzun bir döngüyü iş modelinin ölçeklenebilirliği konusunda büyük bir endişe kaynağı olarak görürler.",
                        "Bu süre, ürünün pazara uyumunda veya satış sürecinde ciddi verimsizlikler olduğuna işaret edebilir."
                    ]
                },
                {
                    option: '12 ay ve üzeri',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "On iki aydan uzun bir satış döngüsü, bir girişim için sürdürülemezdir ve genellikle yatırım yapılamaz olarak kabul edilir.",
                        "Bu kadar uzun bir geri dönüş süresi, şirketin gelir elde etmeden önce tüm sermayesini tüketme riskini en üst düzeye çıkarır.",
                        "Bu durum, ürün-pazar uyumunun zayıf olduğuna veya değer önerisinin net olmadığına işaret edebilir.",
                        "Hedeflenen pazarın ürünü benimsemeye hazır olmadığı da bir başka olası nedendir.",
                        "Bu, iş modelinin temelden kusurlu olduğunun ve ölçeklenemeyeceğinin güçlü bir göstergesidir."
                    ]
                }
            ] 
        },
        { 
            id: 'q33', 
            text: 'Müşteri geri bildirimlerine göre ürününüzü ne kadar hızlı geliştirebiliyorsunuz?', 
            type: 'radio', 
            options: [
                {
                    option: 'Çok hızlı, düzenli güncelleme',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Müşteri geri bildirimlerine çok hızlı adapte olmak, çevik ve müşteri odaklı bir kültürü gösterir.",
                        "Bu, şirketin 'Yap-Ölç-Öğren' döngüsünü etkin bir şekilde uyguladığının kanıtıdır.",
                        "Bu yetenek, ürünün sürekli iyileştirilmesini ve müşteri memnuniyetinin artırılmasını sağlar.",
                        "Rekabet avantajının korunmasına yardımcı olur.",
                        "Yatırımcılar, bu adaptasyon hızını takımın yürütme yeteneğinin önemli bir göstergesi olarak değerlendirir."
                    ]
                },
                {
                    option: 'Orta hızda, ara sıra güncelleme',
                    value: 35000,
                    type: 'potential',
                    sentences: [
                        "Orta hızda bir adaptasyon, şirketin müşteri geri bildirimlerini dikkate aldığını ancak süreçlerinin tam optimize edilmediğini gösterir.",
                        "Bu durum, pazardaki fırsatları yakalamada gecikmelere neden olabilir.",
                        "Rekabetçi tehditlere yanıt vermede yavaş kalınabilir.",
                        "Girişim, geliştirme ve geri bildirim döngülerini hızlandırma potansiyeline sahiptir.",
                        "Bu, yönetilebilir bir durumdur ancak şirketin tam potansiyeline ulaşmasını engelleyebilir."
                    ]
                },
                {
                    option: 'Yavaş, nadiren güncelleme',
                    value: 12500,
                    type: 'risk',
                    sentences: [
                        "Geri bildirimlere yavaş yanıt vermek, pazardan kopuk olunduğuna ve rekabetin gerisinde kalma riskine işaret eder.",
                        "Bu durum, müşterilerin ihtiyaçlarının karşılanmamasına ve zamanla rakiplere yönelmelerine neden olabilir.",
                        "Yavaş iterasyon hızı, takımın çevik olmadığını ve öğrenme döngüsünün verimsiz olduğunu gösterir.",
                        "Yatırımcılar için bu, girişimin pazar dinamiklerine uyum sağlama yeteneği konusunda ciddi bir endişe kaynağıdır.",
                        "Bu durum, ürünün zamanla alakasız hale gelme riskini artırır."
                    ]
                },
                {
                    option: 'Güncelleme yapılmıyor',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Müşteri geri bildirimlerine hiç yanıt vermemek, ürünün ve şirketin durağan olduğunun bir işaretidir.",
                        "Bu, pazarın ve müşterilerin ihtiyaçlarının tamamen göz ardı edildiği anlamına gelir.",
                        "Bu yaklaşım, kaçınılmaz olarak ürünün alakasız hale gelmesine ve müşteri kaybına yol açar.",
                        "Bu, yatırımcılar için kabul edilemez bir durumdur.",
                        "Girişimin temelden kusurlu bir yönetim anlayışına sahip olduğunu gösterir."
                    ]
                }
            ] 
        },
        { 
            id: 'q34', 
            text: 'Pazara giriş stratejisi net mi?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Net bir pazara giriş (GTM) stratejisi, takımın hedef müşterisine nasıl ulaşacağını anladığını gösterir.",
                        "Bu netlik, pazarlama ve satış çabalarının odaklı ve verimli olmasını sağlar.",
                        "İyi bir GTM stratejisi, hedef pazar segmentlerini, değer önerisini, fiyatlandırmayı ve dağıtım kanallarını içerir.",
                        "Yatırımcılar için bu, takımın sadece bir ürün değil, aynı zamanda bir iş kurma konusunda stratejik bir plana sahip olduğunun kanıtıdır.",
                        "Bu, kaynakların etkili bir şekilde kullanılması anlamına gelir."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Net bir pazara giriş stratejisinin olmaması, büyük bir belirsizlik ve yürütme riski yaratır.",
                        "Takım, hedef müşterisine nasıl ulaşacağını bilmeden kaynak ayırırsa, bu çabaların boşa gitme olasılığı yüksektir.",
                        "Bu durum, genellikle yavaş büyümeye ve yüksek müşteri edinme maliyetlerine yol açar.",
                        "Pazar payı kazanamama riski artar.",
                        "Yatırımcılar, stratejik bir yol haritasının olmamasını takımın ticari zekadan yoksun olduğunun bir işareti olarak görürler."
                    ]
                }
            ] 
        },
        { 
            id: 'q35', 
            text: 'Farklı pazarlarda deneyim var mı?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Farklı pazarlarda deneyim sahibi olmak, girişimin uyum sağlama ve ölçeklenme yeteneğini gösterir.",
                        "Bu, iş modelinin tek bir pazara aşırı bağımlı olmadığını ve daha geniş bir büyüme potansiyeline sahip olduğunu kanıtlar.",
                        "Bu deneyim, şirketin farklı pazar dinamiklerini ve müşteri davranışlarını anlama kapasitesini gösterir.",
                        "Yatırımcılar için bu, çeşitlendirilmiş bir büyüme stratejisinin ve daha düşük pazar konsantrasyonu riskinin bir işaretidir.",
                        "Farklı düzenleyici ortamlara uyum sağlama yeteneğini de kanıtlar."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Deneyimin tek bir pazarda yoğunlaşması, girişimi o pazarın dinamiklerine karşı savunmasız bırakır.",
                        "Pazarda meydana gelebilecek bir gerileme veya artan rekabet, şirketin tamamını riske atabilir.",
                        "Düzenleyici değişiklikler de ciddi bir tehdit oluşturabilir.",
                        "Farklı pazarlarda deneyim eksikliği, girişimin ölçeklenme yeteneği konusunda soru işaretleri yaratır.",
                        "Yatırımcılar, bu durumu büyüme potansiyelini sınırlayan ve riski artıran bir faktör olarak değerlendirebilir."
                    ]
                }
            ] 
        },
        { 
            id: 'q36', 
            text: 'İş modeli ölçeklenebilir mi?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Ölçeklenebilir bir iş modeli, gelirin maliyetlerden önemli ölçüde daha hızlı artabileceği anlamına gelir.",
                        "Bu, risk sermayesi yatırımı için temel bir gerekliliktir.",
                        "Yazılım-hizmet (SaaS) gibi modeller, düşük marjinal maliyetleri nedeniyle doğal olarak ölçeklenebilirdir.",
                        "Bu durum, yüksek kar marjlarına ve üstel büyümeye olanak tanır.",
                        "Ölçeklenebilirlik, girişimin büyük bir pazara hizmet etme ve önemli bir yatırım getirisi sağlama potansiyelini gösterir."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Ölçeklenemeyen bir iş modeli, büyümenin doğrudan maliyet artışına bağlı olduğu anlamına gelir.",
                        "Bu tür hizmet veya danışmanlık odaklı işletmeler karlı olabilir, ancak genellikle risk sermayesinin aradığı üstel büyümeyi sağlayamazlar.",
                        "Büyüme potansiyelinin doğrusal olması, yatırımın getirisini sınırlar.",
                        "Bu durum, onu risk sermayesi için daha az çekici hale getirir.",
                        "Bu tür bir model, genellikle 'yaşam tarzı işi' olarak kabul edilir ve büyük ölçekli yatırım için uygun değildir."
                    ]
                }
            ] 
        },
        { 
            id: 'q37', 
            text: 'Birden fazla gelir kaynağı oluşturma potansiyeli var mı?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 25000,
                    type: 'potential',
                    sentences: [
                        "Birden fazla gelir akışına sahip olma potansiyeli, iş modelinin esnekliğini ve dayanıklılığını artırır.",
                        "Bu, şirketin gelirini çeşitlendirmesine ve tek bir gelir kaynağına olan bağımlılığı azaltmasına olanak tanır.",
                        "Müşteri yaşam boyu değerini (LTV) artırma potansiyeli sunar.",
                        "Örneğin, bir yazılım şirketi abonelik ücretlerinin yanı sıra veri analitiği hizmetleri de sunabilir.",
                        "Yatırımcılar için bu, daha sağlam bir finansal yapıya ve ek büyüme yollarına işaret eden olumlu bir sinyaldir."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Tek bir gelir akışına bağımlı olmak, işi pazar değişikliklerine karşı daha savunmasız hale getirir.",
                        "Müşteri tercihlerindeki değişimler veya rekabetçi baskılar ciddi riskler oluşturur.",
                        "Bu, gelir konsantrasyonu riskini artırır ve büyüme potansiyelini sınırlar.",
                        "Girişimin, uzun vadede sürdürülebilirliği sağlamak için gelir kaynaklarını çeşitlendirme yollarını araştırması önemlidir.",
                        "Yatırımcılar, bu durumu iş modelinin esnekliğinin sınırlı olduğunun bir göstergesi olarak değerlendirebilir."
                    ]
                }
            ] 
        },
        { 
            id: 'q38', 
            text: 'Ürününüzün satışını gerçekleştirdiniz mi?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 125000,
                    type: 'potential',
                    sentences: [
                        "Gerçekleşen satışlar, bir girişimin ilerlemesindeki en önemli doğrulama noktasıdır.",
                        "Bu, müşterilerin ürün için para ödemeye istekli olduklarını kanıtlar; bu, ürün-pazar uyumuna doğru atılmış en somut adımdır.",
                        "Satışlar, iş modelinin uygulanabilir olduğunu ve değer önerisinin yankı bulduğunu gösterir.",
                        "Yatırımcılar için ilk satışlar, pazar riskini önemli ölçüde azaltan en güçlü sinyaldir.",
                        "Bu, varsayımların ötesine geçip gerçek pazar doğrulaması elde edildiği anlamına gelir."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Henüz hiç satış yapılmamış olması, girişimin hala en riskli aşamada olduğunu gösterir.",
                        "Pazarın ürünü benimseyip benimsemeyeceği ve ödeme yapıp yapmayacağı belirsizdir.",
                        "Bu durum, ürün-pazar uyumunun henüz doğrulanmadığı anlamına gelir.",
                        "Satışların olmaması, yatırımcılar için en büyük belirsizlik kaynağıdır.",
                        "Girişimin en acil önceliği, ilk ödeme yapan müşterileri bularak bu temel varsayımı doğrulamak olmalıdır."
                    ]
                }
            ] 
        },
    ]
  },
  {
    title: '5. Fikri Mülkiyet ve Psikoloji',
    questions: [
        { 
            id: 'q40', 
            text: 'Şirketin kendisine ait fikri mülkiyet hakları var mı?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Fikri mülkiyetin (FM) tamamen şirkete ait olması, girişimin en değerli varlıklarından birini güvence altına alarak gelecekteki yasal anlaşmazlıkları önler.",
                        "Bu durum, yatırımcılar için temel bir durum tespiti maddesidir, zira FM mülkiyetindeki belirsizlikler yatırımı engelleyebilir.",
                        "Tüm kurucuların ve çalışanların FM'lerini şirkete devrettiği net anlaşmalar, şirketin temel varlıkları üzerinde tam kontrole sahip olduğunu gösterir.",
                        "Bu yasal netlik, şirketin değerlemesini ve savunulabilirliğini doğrudan etkileyen kritik bir unsurdur.",
                        "FM'nin güvence altında olması, şirketin uzun vadeli rekabet avantajını korumasına yardımcı olur."
                    ]
                },
                {
                    option: 'Başvuru aşamasında',
                    value: 25000,
                    type: 'potential',
                    sentences: [
                        "Fikri mülkiyet koruması için başvuruda bulunulmuş olması, takımın FM'nin öneminin farkında olduğunu gösteren olumlu bir işarettir.",
                        "Bu, onu korumak için proaktif adımlar atıldığını gösterir.",
                        "Henüz tescil edilmemiş olsa da, başvuru süreci şirketin varlıklarını koruma niyetini ortaya koyar.",
                        "Ancak, başvurunun onaylanacağının garantisi olmadığı için hala bir miktar belirsizlik ve risk mevcuttur.",
                        "Yatırımcılar, başvuru sürecinin durumunu ve başarı olasılığını yakından takip edecektir."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Şirketin fikri mülkiyetin sahibi olmaması, büyük bir yasal ve ticari risktir.",
                        "Bu durum, girişimin temel teknolojisinin veya markasının başkaları tarafından hak iddia edilmesine açık olduğu anlamına gelir.",
                        "Bu belirsizlik, yatırımcılar için kabul edilemez bir risktir ve genellikle bir anlaşmayı engeller.",
                        "Fikri mülkiyetin korunmaması, şirketin en değerli varlıklarını savunmasız bırakır.",
                        "Uzun vadeli rekabet avantajı oluşturma yeteneğini baltalar."
                    ]
                }
            ] 
        },
        { 
            id: 'q41', 
            text: 'Ürününüz için sertifikalar alındı mı? (CE, ISO vb.)', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 100000,
                    type: 'potential',
                    sentences: [
                        "CE, ISO gibi sektöre özgü sertifikaların alınmış olması, ürünün kalite ve güvenlik standartlarına uygunluğunun güçlü bir kanıtıdır.",
                        "Bu, özellikle sağlık teknolojileri gibi sıkı düzenlemelere tabi sektörlerde kritik bir pazara giriş engelini aştığını gösterir.",
                        "Sertifikalar, ürünün güvenilirliğini artırır ve müşteri nezdinde güven oluşturur.",
                        "Belirli pazarlara erişim için bir ön koşul olabilir.",
                        "Yatırımcılar için bu, önemli bir düzenleyici riskin aşıldığının ve ürünün ticarileşmeye hazır olduğunun bir işaretidir."
                    ]
                },
                {
                    option: 'Başvuru aşamasında',
                    value: 25000,
                    type: 'potential',
                    sentences: [
                        "Sertifikasyon için başvuru yapılmış olması, takımın düzenleyici gerekliliklerin farkında olduğunu gösterir.",
                        "Bu, olumlu bir adımdır ancak sertifikasyon sürecinin kendisi zaman alıcı ve maliyetli olabilir.",
                        "Sonucunun belirsiz olması bir risk faktörüdür.",
                        "Başvurunun reddedilme veya gecikme riski, ürünün pazara çıkışını erteleyebilir.",
                        "Yatırımcılar, nihai onay alınana kadar düzenleyici riski tam olarak ortadan kalkmış saymazlar."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Gerekli sertifikaların alınmamış olması, özellikle düzenlemeye tabi sektörlerde büyük bir kırmızı bayraktır.",
                        "Bu, ürünün yasal olarak pazara sunulamayacağı anlamına gelebilir.",
                        "Önemli güvenlik ve kalite standartlarını karşılamadığı şüphesini doğurur.",
                        "Bu eksiklik, girişimin ticarileşme yeteneği konusunda ciddi şüpheler yaratır.",
                        "Takımın bu kritik adımı göz ardı etmesi, sektör gereklilikleri konusundaki deneyimsizliğine işaret edebilir."
                    ]
                }
            ] 
        },
        { 
            id: 'q42', 
            text: 'Şirketinizin yasal kuruluş türü', 
            type: 'radio', 
            options: [
                {
                    option: 'Anonim Şirket (A.Ş.)',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Anonim Şirket (A.Ş.) yapısı, risk sermayesi yatırımı almak isteyen girişimler için altın standarttır.",
                        "Bu yapı, hisse senedi ihracı ve opsiyon havuzları (ESOP) oluşturma için esneklik sağlar.",
                        "Yatırımcılar, A.Ş. yapısını kurumsal yönetim ve ölçeklenebilirlik için en uygun yapı olarak görürler.",
                        "Gelecekteki bir halka arz (IPO) veya satın alma (M&A) için de en uygun yapıdır.",
                        "Bu yasal yapıyı seçmek, takımın büyük düşündüğünü ve risk sermayesi yolculuğuna hazırlıklı olduğunu gösterir."
                    ]
                },
                {
                    option: 'Limited Şirket (Ltd. Şti.)',
                    value: 40000,
                    type: 'risk',
                    sentences: [
                        "Limited Şirket (Ltd. Şti.) yapısı, başlangıç için yaygın bir seçimdir ancak risk sermayesi yatırımı için ideal değildir.",
                        "Hisse devirleri ve yeni yatırımcıların katılımı A.Ş.'ye göre daha hantal ve masraflıdır.",
                        "Birçok yatırımcı, yatırım yapmadan önce şirketin bir A.Ş.'ye dönüştürülmesini talep edecektir.",
                        "Bu dönüşüm, ek yasal maliyetler ve zaman kaybı anlamına gelir.",
                        "Bu yapı, risk sermayesi yolculuğunun erken aşamalarında bir engel olarak görülebilir."
                    ]
                },
                {
                    option: 'Şahıs Şirketi',
                    value: 20000,
                    type: 'risk',
                    sentences: [
                        "Şahıs şirketi, kurucunun kişisel varlıkları ile şirketin borçları arasında yasal bir ayrım yapmaz.",
                        "Bu sınırsız sorumluluk, hem kurucu hem de potansiyel yatırımcılar için kabul edilemez bir risktir.",
                        "Ayrıca, bu yapı hisse senedi ihraç edemez.",
                        "Dışarıdan sermaye alarak ölçeklenemez.",
                        "Yatırımcılar, bu yapıyı profesyonellikten uzak ve yatırım yapılamaz olarak görürler."
                    ]
                },
                {
                    option: 'Adi Ortaklık',
                    value: 10000,
                    type: 'risk',
                    sentences: [
                        "Adi ortaklık, tüzel kişiliği olmayan ve ortakların şirket borçlarından müştereken sorumlu olduğu bir yapıdır.",
                        "Bu, şahıs şirketine benzer şekilde, kurucular için büyük bir kişisel mali risk oluşturur.",
                        "Ölçeklenme ve yatırım alma açısından tamamen yetersizdir.",
                        "Kurumsal bir yapı oluşturma imkanı sunmaz.",
                        "Girişimcilik ekosisteminde ciddi bir iş kurmak için uygun bir yapı olarak kabul edilmez."
                    ]
                },
                {
                    option: 'Henüz kurulmadı',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Şirketin henüz yasal olarak kurulmamış olması, girişimin hala fikir aşamasında olduğunu gösterir.",
                        "Operasyonel olarak faaliyete geçmediği anlamına gelir.",
                        "Yatırımcılar genellikle yasal bir varlık olmadan yatırım yapmazlar.",
                        "Bu durum, takımın işi ciddiye alma konusunda geciktiğini gösterebilir.",
                        "Yatırım sürecinin ilerlemesi için ilk adım, uygun yasal yapının kurulması olacaktır."
                    ]
                },
                {
                    option: 'Diğer',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Standart olmayan yasal yapılar, yatırım süreçlerini karmaşıklaştırabilir.",
                        "Yatırımcılar, aşina olmadıkları yapılara yatırım yapma konusunda isteksiz olabilirler.",
                        "Bu tür yapılar, hisse devri veya yeni ortakların eklenmesi gibi konularda yasal zorluklar çıkarabilir.",
                        "Girişimin, neden standart bir yapı seçmediğini net bir şekilde açıklaması gerekir.",
                        "Bu durum, yatırımcılar için ek bir durum tespiti (due diligence) yükü anlamına gelir."
                    ]
                }
            ] 
        },
        { 
            id: 'q43', 
            text: 'Kurucuların durum tespiti (due diligence) belgeleri var mı?', 
            type: 'radio', 
            options: [
                {
                    option: 'Evet',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Kurucuların, durum tespiti süreci için gerekli tüm belgeleri hazır bulundurması, profesyonellik ve hazırlıklı olmanın bir işaretidir.",
                        "Bu, yatırım sürecini önemli ölçüde hızlandırır.",
                        "Yatırımcıya takımın organize ve şeffaf olduğu konusunda güven verir.",
                        "Belgelerin eksiksiz olması, potansiyel yasal veya operasyonel sorunların önceden çözüldüğünü gösterir.",
                        "Bu, yatırımcı nezdinde olumlu bir izlenim bırakır ve anlaşmanın sorunsuz ilerlemesine yardımcı olur."
                    ]
                },
                {
                    option: 'Hayır',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Durum tespiti belgelerinin hazır olmaması, yatırım sürecinde önemli gecikmelere neden olur.",
                        "Bu durum, takımın hazırlıksız veya organize olamadığı izlenimini yaratabilir.",
                        "Daha da kötüsü, bu süreçte ortaya çıkabilecek beklenmedik yasal sorunlar yatırımcının anlaşmadan çekilmesine neden olabilir.",
                        "Örneğin, Fikri Mülkiyet mülkiyeti sorunları veya düzensiz muhasebe kayıtları ciddi problemler yaratabilir.",
                        "Hazırlıksızlık, yatırımcının takıma olan güvenini sarsabilir ve tüm süreci riske atabilir."
                    ]
                }
            ] 
        },
        { 
            id: 'q44', 
            text: 'Şirketin finansal kaynakları ve nakit yönetimi ne durumda?', 
            type: 'radio', 
            options: [
                {
                    option: 'Yeterli finansal kaynak ve sağlıklı nakit akışı',
                    value: 130000,
                    type: 'potential',
                    sentences: [
                        "Yeterli finansal kaynaklara sahip olmak, girişimin operasyonel olarak istikrarlı olduğunu gösterir.",
                        "Sağlıklı bir nakit akışı, şirketin stratejik hedeflerine odaklanmak için yeterli 'piste' (runway) sahip olduğunu kanıtlar.",
                        "Bu durum, şirketin beklenmedik harcamalar veya gelir gecikmeleri karşısında dayanıklı olmasını sağlar.",
                        "Sağlıklı nakit yönetimi, takımın finansal disipline ve öngörüye sahip olduğunun bir kanıtıdır.",
                        "Yatırımcılar için bu, sermayelerinin büyümeyi hızlandırmak için kullanılacağını gösteren en olumlu finansal senaryodur."
                    ]
                },
                {
                    option: 'Kaynaklar sınırlı, ancak yönetilebilir',
                    value: 75000,
                    type: 'potential',
                    sentences: [
                        "Sınırlı ancak yönetilebilir kaynaklara sahip olmak, erken aşama girişimler için yaygın bir durumdur.",
                        "Bu, takımın kaynaklarını dikkatli bir şekilde yönetmesi ve harcamalarını önceliklendirmesi gerektiği anlamına gelir.",
                        "Nakit akışı sıkı bir şekilde izlenmeli ve beklenmedik durumlara karşı bir tampon bulundurulmalıdır.",
                        "Bu durum, yatırımcılar için bir endişe kaynağı olabilir, ancak takımın tutumlu olduğunu da gösterebilir.",
                        "Yatırımın zamanlaması bu senaryoda kritik hale gelir."
                    ]
                },
                {
                    option: 'Finansal kaynak yetersiz ve risk altında',
                    value: 20000,
                    type: 'risk',
                    sentences: [
                        "Yetersiz finansal kaynaklar, girişimin hayatta kalma tehlikesiyle karşı karşıya olduğunu gösterir.",
                        "Bu durum, şirketin maaşları ödeyememe veya iflas etme riski altında olduğu anlamına gelir.",
                        "Bu finansal istikrarsızlık, takımı stratejik hedeflerden uzaklaştırır ve tüm odağı 'hayatta kalmaya' yöneltir.",
                        "Yatırımcılar için bu, son derece yüksek riskli bir durumdur.",
                        "Genellikle acil bir 'köprü finansmanı' gerektirir, bu da mevcut hissedarlar için olumsuz şartlar anlamına gelebilir."
                    ]
                }
            ] 
        },
        { 
            id: 'q45', 
            text: 'Ortaklar olarak, iş yükü ve sorumluluklar nedeniyle duygusal tükenme sıklığınız', 
            type: 'radio', 
            options: [
                {
                    option: 'Hiçbir zaman',
                    value: 100000,
                    type: 'potential',
                    sentences: [
                        "Kurucuların duygusal tükenmişlik yaşamaması, yüksek düzeyde dayanıklılık ve etkili stres yönetimi becerilerine işaret eder.",
                        "Bu durum, kurucuların kişisel sağlıkları ile iş talepleri arasında sağlıklı bir denge kurabildiklerini gösterir.",
                        "Araştırmalar, kurucu tükenmişliğinin girişim başarısızlığının önde gelen nedenlerinden biri olduğunu göstermektedir.",
                        "Düşük tükenmişlik seviyeleri, girişimin uzun vadeli sağlığı için çok olumlu bir sinyaldir.",
                        "Bu psikolojik dayanıklılık, liderlik ekibinin etkinliğini ve şirketin sürdürülebilirliğini artırır."
                    ]
                },
                {
                    option: 'Nadiren',
                    value: 100000,
                    type: 'potential',
                    sentences: [
                        "Nadiren tükenmişlik yaşamak, yüksek düzeyde dayanıklılık ve etkili stres yönetimi becerilerine işaret eder.",
                        "Bu durum, kurucuların kişisel sağlıkları ile iş talepleri arasında sağlıklı bir denge kurabildiklerini gösterir.",
                        "Araştırmalar, kurucu tükenmişliğinin girişim başarısızlığının önde gelen nedenlerinden biri olduğunu göstermektedir.",
                        "Düşük tükenmişlik seviyeleri, girişimin uzun vadeli sağlığı için çok olumlu bir sinyaldir.",
                        "Bu psikolojik dayanıklılık, liderlik ekibinin etkinliğini ve şirketin sürdürülebilirliğini artırır."
                    ]
                },
                {
                    option: 'Bazen',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Ara sıra tükenmişlik yaşamak, girişimcilik yolculuğunun doğal bir parçasıdır ve yönetilebilir bir durumdur.",
                        "Bu, kurucuların zaman zaman yoğun baskı altında kaldıklarını ancak genellikle bununla başa çıkabildiklerini gösterir.",
                        "Ancak bu, potansiyel risklerin bir işareti olabilir.",
                        "Takımın proaktif olarak stres yönetimi stratejileri geliştirmesi gerektiğini gösterir.",
                        "Bu durumun 'sık' veya 'her zaman' seviyesine ilerlemesini önlemek için önlemler alınmalıdır."
                    ]
                },
                {
                    option: 'Sıklıkla',
                    value: 25000,
                    type: 'risk',
                    sentences: [
                        "Sık sık tükenmişlik yaşanması, kurucuların sürdürülemez bir tempoda çalıştığını gösteren ciddi bir uyarı işaretidir.",
                        "Kişisel refahlarının risk altında olduğunu gösterir.",
                        "Bu durum, karar verme kalitesini ve takım içi ilişkileri olumsuz etkileyebilir.",
                        "Bu seviyedeki tükenmişlik, genellikle iş-yaşam dengesindeki ciddi sorunlara işaret eder.",
                        "Bu durumun devam etmesi, hem kurucuların sağlığı hem de şirketin geleceği için ciddi bir tehdit oluşturur."
                    ]
                },
                {
                    option: 'Her zaman',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Sürekli tükenmişlik hali, kurucuların hem zihinsel hem de fiziksel olarak sınırlarına ulaştığını gösteren kritik bir durumdur.",
                        "Bu, liderlik ekibinin işlevsiz hale gelme riskiyle karşı karşıya olduğu anlamına gelir.",
                        "Şirketin stratejik yönünü kaybetme riski yüksektir.",
                        "Bu seviyedeki tükenmişlik, genellikle kaçınılmaz bir başarısızlığın habercisidir.",
                        "Yatırımcılar için bu, girişimin temelden istikrarsız ve yönetilemez olduğunun açık bir göstergesidir."
                    ]
                }
            ] 
        },
        { 
            id: 'q46', 
            text: 'Ortakların genel motivasyon, memnuniyet ve psikolojik durumunu nasıl değerlendirirsiniz?', 
            type: 'radio', 
            options: [
                {
                    option: 'Ortakların motivasyonu, ruhsal durumu ve yaşam memnuniyeti oldukça yüksek.',
                    value: 100000,
                    type: 'potential',
                    sentences: [
                        "Kurucuların genel psikolojik iyi oluşlarının çok iyi olması, zorluklarla başa çıkma kapasitelerinin yüksek olduğunu gösterir.",
                        "Baskı altında sakin kalma ve pozitif bir bakış açısını sürdürme yeteneklerini kanıtlar.",
                        "Yüksek yaşam memnuniyeti, daha iyi karar verme ve artan yaratıcılık ile ilişkilidir.",
                        "Bu, sadece kurucuların kişisel sağlığı için değil, aynı zamanda şirketin kültürü ve performansı için de olumlu bir temel oluşturur.",
                        "Bu durum, takımın girişimciliğin getirdiği iniş çıkışlara karşı dayanıklı olacağını gösterir."
                    ]
                },
                {
                    option: 'Genel olarak memnunlar; küçük stres veya sorunlar olsa da işleyişi etkilemiyor.',
                    value: 75000,
                    type: 'potential',
                    sentences: [
                        "İyi düzeyde bir psikolojik refah, kurucuların genel olarak sağlıklı bir zihinsel durumda olduklarını gösterir.",
                        "İşin talepleriyle başa çıkabildiklerini kanıtlar.",
                        "Bu, istikrarlı bir liderlik ve etkili bir yönetim için sağlam bir temel sunar.",
                        "Bu seviye, sürdürülebilir bir performans için olumlu bir göstergedir.",
                        "Takımın zorluklar karşısında dayanıklılığını koruyabileceğine işaret eder."
                    ]
                },
                {
                    option: 'Ne belirgin şekilde memnun ne de memnuniyetsizler; durum dönemsel olarak değişkenlik gösteriyor.',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Orta düzeyde bir psikolojik iyi oluş, bazı stres faktörlerinin kurucuları etkilemeye başladığını gösterebilir.",
                        "Bu durum, performanslarını veya karar verme yeteneklerini olumsuz etkileme potansiyeline sahiptir.",
                        "Bu, proaktif destek ve müdahale gerektirebilecek bir uyarı işaretidir.",
                        "Takımın, refahlarını artırmak için adımlar atması önemlidir.",
                        "Uzun vadeli başarı için bu durumun iyileştirilmesi gerekir."
                    ]
                },
                {
                    option: 'Düşük motivasyon, stres ve memnuniyetsizlik belirgin şekilde görülüyor.',
                    value: 25000,
                    type: 'risk',
                    sentences: [
                        "Düşük psikolojik iyi oluş, kurucuların önemli bir zihinsel sıkıntı içinde olduğunu gösterir.",
                        "Bu durum, liderlik kapasitelerini ve karar verme yeteneklerini ciddi şekilde tehlikeye atar.",
                        "Genel olarak şirketi yönetme becerilerini olumsuz etkiler.",
                        "Bu, hem bireysel hem de kurumsal düzeyde yüksek bir risk faktörüdür.",
                        "Yatırımcılar, bu durumu girişimin liderliğinin temelden zayıf olduğu şeklinde değerlendirir."
                    ]
                },
                {
                    option: 'Ortakların motivasyonu ve yaşam memnuniyeti oldukça düşük; bu durum iş süreçlerini olumsuz etkiliyor.',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Düşük psikolojik iyi oluş, kurucuların önemli bir zihinsel sıkıntı içinde olduğunu gösterir.",
                        "Bu durum, liderlik kapasitelerini ve karar verme yeteneklerini ciddi şekilde tehlikeye atar.",
                        "Genel olarak şirketi yönetme becerilerini olumsuz etkiler.",
                        "Bu, hem bireysel hem de kurumsal düzeyde yüksek bir risk faktörüdür.",
                        "Yatırımcılar, bu durumu girişimin liderliğinin temelden zayıf olduğu şeklinde değerlendirir."
                    ]
                }
            ] 
        },
        { 
            id: 'q47', 
            text: 'Çevrenizden aldığınız duygusal ve sosyal destek nasıl?', 
            type: 'radio', 
            options: [
                {
                    option: 'Güçlü',
                    value: 50000,
                    type: 'potential',
                    sentences: [
                        "Güçlü bir duygusal ve sosyal destek ağı, girişimcilerin karşılaştığı yoğun stresle başa çıkmaları için hayati bir kaynaktır.",
                        "Bu ağ, dayanıklılığı artırır ve tükenmişliği önler.",
                        "Zor zamanlarda dışarıdan bir bakış açısı ve teşvik sağlar.",
                        "Güçlü bir destek sistemine sahip olmak, kurucuların zihinsel sağlıklarını korumalarına yardımcı olur.",
                        "Yatırımcılar, bu faktörü kurucunun kişisel dayanıklılığının bir göstergesi olarak görürler."
                    ]
                },
                {
                    option: 'Orta',
                    value: 40000,
                    type: 'potential',
                    sentences: [
                        "Orta düzeyde bir destek ağı, kurucuların bir miktar desteğe sahip olduğunu ancak bu ağın güçlendirilebileceğini gösterir.",
                        "Kurucuların, mentorluk gibi ek kaynaklar araması faydalı olabilir.",
                        "Stres yönetimi ve dayanıklılık konusunda proaktif olmaları önemlidir.",
                        "Bu ağ, temel bir destek sağlasa da, yoğun kriz anlarında yetersiz kalabilir.",
                        "Girişimcilerin bu ağı bilinçli olarak geliştirmesi, uzun vadeli başarı için önemlidir."
                    ]
                },
                {
                    option: 'Zayıf',
                    value: 15000,
                    type: 'risk',
                    sentences: [
                        "Zayıf bir destek ağı, kurucuların stres ve zorluklarla tek başlarına mücadele ettiği anlamına gelir.",
                        "Bu durum, tükenmişlik ve zihinsel sağlık sorunları riskini önemli ölçüde artırır.",
                        "Karar verme süreçlerinde yalnız kalmak, hatalı kararlar alma olasılığını yükseltir.",
                        "Yatırımcılar, bu durumu kurucunun dayanıklılığı ve uzun vadeli performansı için bir risk faktörü olarak görür.",
                        "Girişimcinin acilen mentorlar, danışmanlar veya destek grupları araması gerekir."
                    ]
                },
                {
                    option: 'Çok zayıf',
                    value: 0,
                    type: 'risk',
                    sentences: [
                        "Çok zayıf bir destek ağı, kurucunun izolasyon içinde olduğunu gösteren ciddi bir kırmızı bayraktır.",
                        "Bu durum, tükenmişlik ve zihinsel sağlık sorunları riskini önemli ölçüde artırır.",
                        "Karar verme süreçlerinde yalnız kalmak, hatalı kararlar alma olasılığını yükseltir.",
                        "Yatırımcılar, bu durumu kurucunun dayanıklılığı ve uzun vadeli performansı için bir risk faktörü olarak görür.",
                        "Girişimcinin acilen mentorlar, danışmanlar veya destek grupları araması gerekir."
                    ]
                }
            ] 
        },
    ]
  },
];


export default surveyData;